<template>
  <v-container fluid fill-height class="grey lighten-3 pl-2 pr-2 pt-2" style="overflow: auto">
    <v-layout column>
      <v-flex style="flex-grow: 0">
        <div class="mt-2 mb-2 ob-section-title-and-tabs">
          <h1 class="headline ob-section-title pr-4 primary--text d-flex mb-2">
            <v-avatar class="ob-no-grow-or-shrink mr-2" :class="{ 'ob-rotate': loading }" size="36">
              <img src="/img/tud_group_round_transparent.png" alt="TUD Group company logo">
            </v-avatar>
            {{ translateUI(label, lang) }}
            <v-spacer></v-spacer>
          </h1>
        </div>
      </v-flex>
      <v-flex style="flex-grow: 0">
        <v-stepper v-model="wiz">
          <v-stepper-header style="height: auto">
            <v-stepper-step :complete="wiz > 1" step="1" editable>
              <!-- Selectati tipul setului de date si perioada de referinta -->
              Tip &amp; Perioada
              <div>
                <small class="font-weight-bold primary--text">{{ selectedTipRaport }}</small>
                &nbsp;
                <small class="font-weight-bold primary--text">{{ selectedPerioada }}</small>
              </div>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="wiz > 2" step="2" :editable="!!selectedTipRaport">
              <!-- Selectare APL-uri -->
              APL-uri
              <small class="font-weight-bold primary--text">{{ formattedCifuri.length }}</small>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="wiz > 3" step="3" :editable="!!selectedTipRaport">
              <!-- Selectare elemente Clasificatie Bugetara -->
              Clasificatie Bugetara
              <small class="font-weight-bold primary--text">{{ totalSelectedClasificatie }}</small>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="wiz > 4" step="4" :editable="!!selectedTipRaport">
              <!-- Selectare elemente Indicatori -->
              Indicatori
              <small class="font-weight-bold primary--text">{{ totalSelectedIndicatori }}</small>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="wiz > 5" step="5" :editable="!!selectedTipRaport">
              <v-icon>mdi-flag-checkered</v-icon>
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card flat color="grey lighten-4" class="mb-5" max-height="50vh" style="overflow: auto">
                <v-card-text class="pa-0">
                  <p class="text-xs-center caption font-weight-bold mb-0 mt-2">Tip set de date</p>
                  <div style="display: flex; justify-content: center">
                    <v-btn :color="selectedTipRaport === 'liniar' ? 'accent' : 'grey'" :flat="selectedTipRaport !== 'liniar'" :depressed="selectedTipRaport === 'liniar'" @click="selectedTipRaport = 'liniar'">Liniar</v-btn>
                    <v-btn :color="selectedTipRaport === 'agregat' ? 'accent' : 'grey'" :flat="selectedTipRaport !== 'agregat'" :depressed="selectedTipRaport === 'agregat'" @click="selectedTipRaport = 'agregat'" :disabled="true">Agregat</v-btn>
                  </div>
                  <p class="text-xs-center caption font-weight-bold mb-0 mt-2">Perioada de referinta</p>
                  <div style="display: flex; justify-content: center">
                    <v-radio-group v-model="selectedPerioada" row>
                      <v-radio
                        v-for="p in perioade"
                        :key="p"
                        :label="p"
                        :value="p">
                      </v-radio>
                    </v-radio-group>
                  </div>
                </v-card-text>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-card flat color="grey lighten-4" class="mb-5">
                <v-card-text class="pa-0">
                  <v-layout row wrap>
                    <v-flex xs12 class="d-flex interactive-wizard">
                      <v-subheader class="d-inline-flex">Disponibile</v-subheader>
                      <v-spacer></v-spacer>
                      <v-text-field
                        v-model="aplSearch"
                        prepend-inner-icon="mdi-magnify"
                        label="Cauta"
                        single-line
                        hide-details
                        clearable
                        solo flat box
                        class="pt-0 ob-transparent-textfield">
                      </v-text-field>
                      <v-spacer></v-spacer>
                      <v-subheader class="d-inline-flex" style="justify-content: flex-end">Selectate</v-subheader>
                    </v-flex>
                    <v-flex xs6 class="interactive-wizard">
                      <v-list subheader dense two-line style="max-height: calc(50vh - 132px); height: 100%; overflow: auto; width: 100%">
                        <template v-for="judet in pagedCifuri">
                          <v-divider :key="judet.cif_op + 1"></v-divider>
                          <v-subheader :key="judet.cif_op + 2">{{ judet.judet }}</v-subheader>
                          <v-divider :key="judet.cif_op + 3"></v-divider>
                          <template v-for="cif in judet.children">
                            <v-list-tile :key="'available' + cif.cif_op" :class="{'accent lighten-3': highlightCif(cif) === 'accent' }" class="grey lighten-4">
                              <v-list-tile-avatar>
                                {{ cif.tip_apl.substring(0, 1)}}
                              </v-list-tile-avatar>
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  {{ cif.denumire_apl }}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                  {{ cif.cif_op }}
                                </v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <v-btn icon @click="toggleCifSelection(cif, 1)" :disabled="cif.disabled">
                                  <v-icon color="green">mdi-plus-circle-outline</v-icon>
                                </v-btn>
                              </v-list-tile-action>
                            </v-list-tile>
                          </template>
                        </template>
                      </v-list>
                      <div class="d-flex pa-2" style="align-items: center">
                        <v-btn icon :disabled="cifuriPage === 0" @click="cifuriPage--" style="flex: 0 0 auto !important">
                          <v-icon>mdi-chevron-left</v-icon>
                        </v-btn>
                        <v-select
                          v-model="cifuriPage"
                          :items="cifuriPages"
                          label="Alegeti pagina">
                        </v-select>
                        <v-btn icon :disabled="cifuriPage === cifuriPages.length - 1" @click="cifuriPage++" style="flex: 0 0 auto !important">
                          <v-icon>mdi-chevron-right</v-icon>
                        </v-btn>
                      </div>
                    </v-flex>
                    <v-flex xs6 class="interactive-wizard">
                      <v-list dense two-line style="max-height: calc(50vh - 132px); height: 100%; overflow: auto; width: 100%">
                        <v-list-tile v-for="cif in selectedCifuri" :key="'selected' + cif.cif_op" class="grey lighten-4">
                          <v-list-tile-avatar>
                            <v-btn icon @click="toggleCifSelection(cif, -1)">
                              <v-icon color="red">mdi-close-circle-outline</v-icon>
                            </v-btn>
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title>
                              {{ cif.denumire_apl }}
                            </v-list-tile-title>
                            <v-list-tile-sub-title>
                              {{ cif.cif_op }}
                            </v-list-tile-sub-title>
                          </v-list-tile-content>
                          <v-list-tile-action>
                            <v-menu bottom left :max-height="'50vh'" :close-on-content-click="false">
                              <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on">
                                  <v-icon>mdi-cogs</v-icon>
                                </v-btn>
                              </template>

                              <v-list subheader two-line dense>
                                <v-subheader>Proprietati (selectie valabila pentru toate apl-urile alese)</v-subheader>
                                <v-list-tile @click="toggleCustomization(cif, 'prop', p.value)" v-for="p in cifuriProps" :key="p.value">
                                  <v-list-tile-action>
                                    <v-checkbox v-model="cif.props" :value="p.value" @click.prevent>
                                    </v-checkbox>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-title>
                                      {{ p.meaning }}
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title>
                                      {{ p.value }}
                                    </v-list-tile-sub-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                              </v-list>
                            </v-menu>
                          </v-list-tile-action>
                        </v-list-tile>
                      </v-list>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="3">
              <v-card flat color="grey lighten-4" class="mb-5">
                <v-card-text class="pa-0">
                  <v-layout row wrap>
                    <v-flex xs12 class="d-flex interactive-wizard">
                      <v-subheader class="d-inline-flex">Disponibile</v-subheader>
                      <v-spacer></v-spacer>
                      <v-text-field
                        v-model="clasificatieSearch"
                        prepend-inner-icon="mdi-magnify"
                        label="Cauta"
                        single-line
                        hide-details
                        clearable
                        solo flat box
                        class="pt-0 ob-transparent-textfield">
                      </v-text-field>
                      <v-spacer></v-spacer>
                      <v-subheader class="d-inline-flex" style="justify-content: flex-end">Selectate</v-subheader>
                    </v-flex>
                    <v-flex xs6 class="interactive-wizard pr-1">
                      <v-tabs grow :show-arrows="true" v-model="clasificatieTab">
                        <v-tab key="ven" ripple>Venituri</v-tab>
                        <v-tab key="chfct" ripple>Ch. Functionale</v-tab>
                        <v-tab key="chec" ripple>Ch. Economice</v-tab>

                        <v-tab-item key="ven">
                          <v-list subheader dense two-line style="max-height: calc(50vh - 145px); height: 100%; overflow: auto; width: 100%">
                            <v-list-tile v-for="venit in pagedVenituri" :key="'selected' + venit._id">
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  {{ venit.denumire }}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                  {{ venit.codec }}
                                </v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <v-btn icon @click="toggleVenitSelection(venit, 1)" :disabled="venit.disabled">
                                  <v-icon color="green">mdi-arrow-right-bold</v-icon>
                                </v-btn>
                              </v-list-tile-action>
                            </v-list-tile>
                          </v-list>
                          <div class="d-flex pa-2" style="align-items: center">
                            <v-btn icon :disabled="venituriPage === 0" @click="venituriPage--" style="flex: 0 0 auto !important">
                              <v-icon>mdi-chevron-left</v-icon>
                            </v-btn>
                            <v-select
                              v-model="venituriPage"
                              :items="venituriPages"
                              dense
                              label="Alegeti pagina">
                            </v-select>
                            <v-btn icon :disabled="venituriPage === venituriPages.length - 1" @click="venituriPage++" style="flex: 0 0 auto !important">
                              <v-icon>mdi-chevron-right</v-icon>
                            </v-btn>
                          </div>
                        </v-tab-item>
                        <v-tab-item key="chfct">
                          <v-list subheader dense two-line style="max-height: calc(50vh - 145px); height: 100%; overflow: auto; width: 100%">
                            <v-list-tile v-for="chfct in pagedChfct" :key="'selected' + chfct._id">
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  {{ chfct.denumire }}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                  {{ chfct.codec }}
                                </v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <v-btn icon @click="toggleChfctSelection(chfct, 1)" :disabled="chfct.disabled">
                                  <v-icon color="green">mdi-arrow-right-bold</v-icon>
                                </v-btn>
                              </v-list-tile-action>
                            </v-list-tile>

                          </v-list>
                          <div class="d-flex pa-2" style="align-items: center">
                            <v-btn icon :disabled="chfctPage === 0" @click="chfctPage--" style="flex: 0 0 auto !important">
                              <v-icon>mdi-chevron-left</v-icon>
                            </v-btn>
                            <v-select
                              v-model="chfctPage"
                              :items="chfctPages"
                              dense
                              label="Alegeti pagina">
                            </v-select>
                            <v-btn icon :disabled="chfctPage === chfctPages.length - 1" @click="chfctPage++" style="flex: 0 0 auto !important">
                              <v-icon>mdi-chevron-right</v-icon>
                            </v-btn>
                          </div>
                        </v-tab-item>
                        <v-tab-item key="chec">
                          <v-list subheader dense two-line style="max-height: calc(50vh - 145px); height: 100%; overflow: auto; width: 100%">
                            <v-list-tile v-for="chec in pagedChec" :key="'selected' + chec._id">
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  {{ chec.denumire }}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                  {{ chec.codec }}
                                </v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <v-btn icon @click="toggleChecSelection(chec, 1)" :disabled="chec.disabled">
                                  <v-icon color="green">mdi-arrow-right-bold</v-icon>
                                </v-btn>
                              </v-list-tile-action>
                            </v-list-tile>
                          </v-list>
                          <div class="d-flex pa-2" style="align-items: center">
                            <v-btn icon :disabled="checPage === 0" @click="checPage--" style="flex: 0 0 auto !important">
                              <v-icon>mdi-chevron-left</v-icon>
                            </v-btn>
                            <v-select
                              v-model="checPage"
                              :items="checPages"
                              dense
                              label="Alegeti pagina">
                            </v-select>
                            <v-btn icon :disabled="checPage === checPages.length - 1" @click="checPage++" style="flex: 0 0 auto !important">
                              <v-icon>mdi-chevron-right</v-icon>
                            </v-btn>
                          </div>
                        </v-tab-item>
                      </v-tabs>
                    </v-flex>
                    <v-flex xs6 class="interactive-wizard pl-1">
                      <v-tabs grow :show-arrows="true" v-model="clasificatieTab">
                        <v-tab key="ven" ripple>Venituri</v-tab>
                        <v-tab key="chfct" ripple>Ch. Functionale</v-tab>
                        <v-tab key="chec" ripple>Ch. Economice</v-tab>

                        <v-tab-item key="ven">
                          <v-list subheader dense two-line style="max-height: calc(50vh - 145px); height: 100%; overflow: auto; width: 100%">
                            <v-list-tile v-for="venit in selectedVenituri" :key="'selected' + venit._id">
                              <v-list-tile-action>
                                <v-btn icon @click="toggleVenitSelection(venit, -1)">
                                  <v-icon color="red">mdi-arrow-left-bold</v-icon>
                                </v-btn>
                              </v-list-tile-action>
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  {{ venit.denumire }}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                  {{ venit.codec }}
                                </v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <v-menu bottom left :max-height="'50vh'" :close-on-content-click="false">
                                  <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                      <v-icon>mdi-cogs</v-icon>
                                    </v-btn>
                                  </template>

                                  <v-list dense subheader>
                                    <v-subheader>Tip valoare</v-subheader>
                                    <v-list-tile @click="toggleCustomization(venit, 'tip', 'executiela')">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="venit.tipuriValori" value="executiela" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>Executie LA Trimestru</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click="toggleCustomization(venit, 'tip', 'executiein')">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="venit.tipuriValori" value="executiein" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>Executie IN Trimestru</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click="toggleCustomization(venit, 'tip', 'y2yla')">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="venit.tipuriValori" value="y2yla" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>Y2Y LA Trimestru</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click="toggleCustomization(venit, 'tip', 'y2yin')">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="venit.tipuriValori" value="y2yin" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>Y2Y IN Trimestru</v-list-tile-title>
                                    </v-list-tile>
                                    <v-divider></v-divider>
                                    <v-subheader>Perioada</v-subheader>
                                    <v-list-tile @click="toggleCustomization(venit, 'perioada', p)" v-for="p in perioade" :key="p">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="venit.perioade" :value="p" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>
                                        {{ p }}
                                      </v-list-tile-title>
                                    </v-list-tile>
                                  </v-list>
                                </v-menu>
                              </v-list-tile-action>
                            </v-list-tile>
                          </v-list>
                        </v-tab-item>
                        <v-tab-item key="chfct">
                          <v-list subheader dense two-line style="max-height: calc(50vh - 145px); height: 100%; overflow: auto; width: 100%">
                            <v-list-tile v-for="chfct in selectedChfct" :key="'selected' + chfct._id">
                              <v-list-tile-action>
                                <v-btn icon @click="toggleChfctSelection(chfct, -1)">
                                  <v-icon color="red">mdi-arrow-left-bold</v-icon>
                                </v-btn>
                              </v-list-tile-action>
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  {{ chfct.denumire }}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                  {{ chfct.codec }}
                                </v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <v-menu bottom left :max-height="'50vh'" :close-on-content-click="false">
                                  <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                      <v-icon>mdi-cogs</v-icon>
                                    </v-btn>
                                  </template>

                                  <v-list dense subheader>
                                    <v-subheader>Tip valoare</v-subheader>
                                    <v-list-tile @click="toggleCustomization(chfct, 'tip', 'executiela')">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="chfct.tipuriValori" value="executiela" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>Executie LA Trimestru</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click="toggleCustomization(chfct, 'tip', 'executiein')">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="chfct.tipuriValori" value="executiein" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>Executie IN Trimestru</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click="toggleCustomization(chfct, 'tip', 'y2yla')">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="chfct.tipuriValori" value="y2yla" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>Y2Y LA Trimestru</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click="toggleCustomization(chfct, 'tip', 'y2yin')">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="chfct.tipuriValori" value="y2yin" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>Y2Y IN Trimestru</v-list-tile-title>
                                    </v-list-tile>
                                    <v-divider></v-divider>
                                    <v-subheader>Perioada</v-subheader>
                                    <v-list-tile @click="toggleCustomization(chfct, 'perioada', p)" v-for="p in perioade" :key="p">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="chfct.perioade" :value="p" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>
                                        {{ p }}
                                      </v-list-tile-title>
                                    </v-list-tile>
                                  </v-list>
                                </v-menu>
                              </v-list-tile-action>
                            </v-list-tile>
                          </v-list>
                        </v-tab-item>
                        <v-tab-item key="chec">
                          <v-list subheader dense two-line style="max-height: calc(50vh - 145px); height: 100%; overflow: auto; width: 100%">
                            <v-list-tile v-for="chec in selectedChec" :key="'selected' + chec._id">
                              <v-list-tile-action>
                                <v-btn icon @click="toggleChecSelection(chec, -1)">
                                  <v-icon color="red">mdi-arrow-left-bold</v-icon>
                                </v-btn>
                              </v-list-tile-action>
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  {{ chec.denumire }}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                  {{ chec.codec }}
                                </v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <v-menu bottom left :max-height="'50vh'" :close-on-content-click="false">
                                  <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                      <v-icon>mdi-cogs</v-icon>
                                    </v-btn>
                                  </template>

                                  <v-list dense subheader>
                                    <v-subheader>Tip valoare</v-subheader>
                                    <v-list-tile @click="toggleCustomization(chec, 'tip', 'executiela')">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="chec.tipuriValori" value="executiela" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>Executie LA Trimestru</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click="toggleCustomization(chec, 'tip', 'executiein')">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="chec.tipuriValori" value="executiein" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>Executie IN Trimestru</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click="toggleCustomization(chec, 'tip', 'y2yla')">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="chec.tipuriValori" value="y2yla" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>Y2Y LA Trimestru</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click="toggleCustomization(chec, 'tip', 'y2yin')">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="chec.tipuriValori" value="y2yin" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>Y2Y IN Trimestru</v-list-tile-title>
                                    </v-list-tile>
                                    <v-divider></v-divider>
                                    <v-subheader>Perioada</v-subheader>
                                    <v-list-tile @click="toggleCustomization(chec, 'perioada', p)" v-for="p in perioade" :key="p">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="chec.perioade" :value="p" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>
                                        {{ p }}
                                      </v-list-tile-title>
                                    </v-list-tile>
                                    <v-divider></v-divider>
                                    <v-subheader>Capitol</v-subheader>
                                    <v-list-tile @click="toggleCustomization(chec, 'codfct', c.cod)" v-for="c in ecParents" :key="c.cod">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="chec.codfct" :value="c.cod" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>
                                        {{ c.codec }}
                                      </v-list-tile-title>
                                    </v-list-tile>
                                  </v-list>
                                </v-menu>
                              </v-list-tile-action>
                            </v-list-tile>
                          </v-list>
                        </v-tab-item>
                      </v-tabs>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="4">
              <v-card flat color="grey lighten-4" class="mb-5">
                <v-card-text class="pa-0">
                  <v-layout row wrap>
                    <v-flex xs12 class="d-flex interactive-wizard">
                      <v-subheader class="d-inline-flex">Disponibile</v-subheader>
                      <v-spacer></v-spacer>
                      <v-text-field
                        v-model="indicatoriSearch"
                        prepend-inner-icon="mdi-magnify"
                        label="Cauta"
                        single-line
                        hide-details
                        clearable
                        solo flat box
                        class="pt-0 ob-transparent-textfield">
                      </v-text-field>
                      <v-spacer></v-spacer>
                      <v-subheader class="d-inline-flex" style="justify-content: flex-end">Selectate</v-subheader>
                    </v-flex>
                    <v-flex xs6 class="interactive-wizard pr-1">
                      <v-tabs grow :show-arrows="true" v-model="indicatoriTab">
                        <v-tab key="ven" ripple>Venituri</v-tab>
                        <v-tab key="ch" ripple>Cheltuieli</v-tab>
                        <v-tab key="int" ripple>Modelare INT</v-tab>
                        <v-tab key="std" ripple>Modelare STD</v-tab>

                        <v-tab-item key="ven">
                          <v-list subheader dense two-line style="max-height: calc(50vh - 145px); height: 100%; overflow: auto; width: 100%">
                            <v-list-tile v-for="venit in pagedIndicatoriVenituri" :key="'selected' + venit._id">
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  {{ venit.denumire }}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                  {{ venit.cod }}
                                </v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <v-btn icon @click="toggleIndicatoriVenitSelection(venit, 1)" :disabled="venit.disabled">
                                  <v-icon color="green">mdi-arrow-right-bold</v-icon>
                                </v-btn>
                              </v-list-tile-action>
                            </v-list-tile>
                          </v-list>
                          <div class="d-flex pa-2" style="align-items: center">
                            <v-btn icon :disabled="indicatoriVenituriPage === 0" @click="indicatoriVenituriPage--" style="flex: 0 0 auto !important">
                              <v-icon>mdi-chevron-left</v-icon>
                            </v-btn>
                            <v-select
                              v-model="indicatoriVenituriPage"
                              :items="indicatoriVenituriPages"
                              dense
                              label="Alegeti pagina">
                            </v-select>
                            <v-btn icon :disabled="indicatoriVenituriPage === indicatoriVenituriPages.length - 1" @click="indicatoriVenituriPage++" style="flex: 0 0 auto !important">
                              <v-icon>mdi-chevron-right</v-icon>
                            </v-btn>
                          </div>
                        </v-tab-item>
                        <v-tab-item key="ch">
                          <v-list subheader dense two-line style="max-height: calc(50vh - 145px); height: 100%; overflow: auto; width: 100%">
                            <v-list-tile v-for="cheltuiala in pagedIndicatoriCheltuieli" :key="'selected' + cheltuiala._id">
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  {{ cheltuiala.denumire }}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                  {{ cheltuiala.cod }}
                                </v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <v-btn icon @click="toggleIndicatoriCheltuialaSelection(cheltuiala, 1)" :disabled="cheltuiala.disabled">
                                  <v-icon color="green">mdi-arrow-right-bold</v-icon>
                                </v-btn>
                              </v-list-tile-action>
                            </v-list-tile>
                          </v-list>
                          <div class="d-flex pa-2" style="align-items: center">
                            <v-btn icon :disabled="indicatoriCheltuieliPage === 0" @click="indicatoriCheltuieliPage--" style="flex: 0 0 auto !important">
                              <v-icon>mdi-chevron-left</v-icon>
                            </v-btn>
                            <v-select
                              v-model="indicatoriCheltuieliPage"
                              :items="indicatoriCheltuieliPages"
                              dense
                              label="Alegeti pagina">
                            </v-select>
                            <v-btn icon :disabled="indicatoriCheltuieliPage === indicatoriCheltuieliPages.length - 1" @click="indicatoriCheltuieliPage++" style="flex: 0 0 auto !important">
                              <v-icon>mdi-chevron-right</v-icon>
                            </v-btn>
                          </div>
                        </v-tab-item>
                        <v-tab-item key="int">
                          <v-list subheader dense two-line style="max-height: calc(50vh - 145px); height: 100%; overflow: auto; width: 100%">
                            <v-list-tile v-for="int in pagedIndicatoriIntepr" :key="'selected' + int._id">
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  {{ int.denumire }}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                  {{ int.cod }}
                                </v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <v-btn icon @click="toggleIndicatoriInteprSelection(int, 1)" :disabled="int.disabled">
                                  <v-icon color="green">mdi-arrow-right-bold</v-icon>
                                </v-btn>
                              </v-list-tile-action>
                            </v-list-tile>
                          </v-list>
                          <div class="d-flex pa-2" style="align-items: center">
                            <v-btn icon :disabled="indicatoriInteprPage === 0" @click="indicatoriInteprPage--" style="flex: 0 0 auto !important">
                              <v-icon>mdi-chevron-left</v-icon>
                            </v-btn>
                            <v-select
                              v-model="indicatoriInteprPage"
                              :items="indicatoriInteprPages"
                              dense
                              label="Alegeti pagina">
                            </v-select>
                            <v-btn icon :disabled="indicatoriInteprPage === indicatoriInteprPages.length - 1" @click="indicatoriInteprPage++" style="flex: 0 0 auto !important">
                              <v-icon>mdi-chevron-right</v-icon>
                            </v-btn>
                          </div>
                        </v-tab-item>
                        <v-tab-item key="std">
                          <v-list subheader dense two-line style="max-height: calc(50vh - 145px); height: 100%; overflow: auto; width: 100%">
                            <v-list-tile v-for="std in pagedIndicatoriStdepr" :key="'selected' + std._id">
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  {{ std.denumire }}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                  {{ std.cod }}
                                </v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <v-btn icon @click="toggleIndicatoriStdeprSelection(std, 1)" :disabled="std.disabled">
                                  <v-icon color="green">mdi-arrow-right-bold</v-icon>
                                </v-btn>
                              </v-list-tile-action>
                            </v-list-tile>
                          </v-list>
                          <div class="d-flex pa-2" style="align-items: center">
                            <v-btn icon :disabled="indicatoriStdeprPage === 0" @click="indicatoriStdeprPage--" style="flex: 0 0 auto !important">
                              <v-icon>mdi-chevron-left</v-icon>
                            </v-btn>
                            <v-select
                              v-model="indicatoriStdeprPage"
                              :items="indicatoriStdeprPages"
                              dense
                              label="Alegeti pagina">
                            </v-select>
                            <v-btn icon :disabled="indicatoriStdeprPage === indicatoriStdeprPages.length - 1" @click="indicatoriStdeprPage++" style="flex: 0 0 auto !important">
                              <v-icon>mdi-chevron-right</v-icon>
                            </v-btn>
                          </div>
                        </v-tab-item>
                      </v-tabs>
                    </v-flex>
                    <v-flex xs6 class="interactive-wizard pl-1">
                      <v-tabs grow :show-arrows="true" v-model="indicatoriTab">
                        <v-tab key="ven" ripple>Venituri</v-tab>
                        <v-tab key="ch" ripple>Cheltuieli</v-tab>
                        <v-tab key="int" ripple>Modelare INT</v-tab>
                        <v-tab key="std" ripple>Modelare STD</v-tab>

                        <v-tab-item key="ven">
                          <v-list subheader dense two-line style="max-height: calc(50vh - 145px); height: 100%; overflow: auto; width: 100%">
                            <v-list-tile v-for="venit in selectedIndicatoriVenituri" :key="'selected' + venit._id">
                              <v-list-tile-action>
                                <v-btn icon @click="toggleIndicatoriVenitSelection(venit, -1)">
                                  <v-icon color="red">mdi-arrow-left-bold</v-icon>
                                </v-btn>
                              </v-list-tile-action>
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  {{ venit.denumire }}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                  {{ venit.cod }}
                                </v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <v-menu bottom left :max-height="'50vh'" :close-on-content-click="false">
                                  <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                      <v-icon>mdi-cogs</v-icon>
                                    </v-btn>
                                  </template>

                                  <v-list dense subheader>
                                    <v-subheader>Tip valoare</v-subheader>
                                    <v-list-tile @click="toggleCustomization(venit, 'tip', 'executiela')">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="venit.tipuriValori" value="executiela" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>Executie LA Trimestru</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click="toggleCustomization(venit, 'tip', 'executiein')">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="venit.tipuriValori" value="executiein" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>Executie IN Trimestru</v-list-tile-title>
                                    </v-list-tile>
                                    <v-divider></v-divider>
                                    <v-subheader>Perioada</v-subheader>
                                    <v-list-tile @click="toggleCustomization(venit, 'perioada', p)" v-for="p in perioade" :key="p">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="venit.perioade" :value="p" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>
                                        {{ p }}
                                      </v-list-tile-title>
                                    </v-list-tile>
                                  </v-list>
                                </v-menu>
                              </v-list-tile-action>
                            </v-list-tile>
                          </v-list>
                        </v-tab-item>
                        <v-tab-item key="ch">
                          <v-list subheader dense two-line style="max-height: calc(50vh - 145px); height: 100%; overflow: auto; width: 100%">
                            <v-list-tile v-for="cheltuiala in selectedIndicatoriCheltuieli" :key="'selected' + cheltuiala._id">
                              <v-list-tile-action>
                                <v-btn icon @click="toggleIndicatoriCheltuialaSelection(cheltuiala, -1)">
                                  <v-icon color="red">mdi-arrow-left-bold</v-icon>
                                </v-btn>
                              </v-list-tile-action>
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  {{ cheltuiala.denumire }}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                  {{ cheltuiala.cod }}
                                </v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <v-menu bottom left :max-height="'50vh'" :close-on-content-click="false">
                                  <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                      <v-icon>mdi-cogs</v-icon>
                                    </v-btn>
                                  </template>

                                  <v-list dense subheader>
                                    <v-subheader>Tip valoare</v-subheader>
                                    <v-list-tile @click="toggleCustomization(cheltuiala, 'tip', 'executiela')">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="cheltuiala.tipuriValori" value="executiela" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>Executie LA Trimestru</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click="toggleCustomization(cheltuiala, 'tip', 'executiein')">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="cheltuiala.tipuriValori" value="executiein" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>Executie IN Trimestru</v-list-tile-title>
                                    </v-list-tile>
                                    <v-divider></v-divider>
                                    <v-subheader>Perioada</v-subheader>
                                    <v-list-tile @click="toggleCustomization(cheltuiala, 'perioada', p)" v-for="p in perioade" :key="p">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="cheltuiala.perioade" :value="p" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>
                                        {{ p }}
                                      </v-list-tile-title>
                                    </v-list-tile>
                                  </v-list>
                                </v-menu>
                              </v-list-tile-action>
                            </v-list-tile>
                          </v-list>
                        </v-tab-item>
                        <v-tab-item key="int">
                          <v-list subheader dense two-line style="max-height: calc(50vh - 145px); height: 100%; overflow: auto; width: 100%">
                            <v-list-tile v-for="int in selectedIndicatoriIntepr" :key="'selected' + int._id">
                              <v-list-tile-action>
                                <v-btn icon @click="toggleIndicatoriInteprSelection(int, -1)">
                                  <v-icon color="red">mdi-arrow-left-bold</v-icon>
                                </v-btn>
                              </v-list-tile-action>
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  {{ int.denumire }}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                  {{ int.cod }}
                                </v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <v-menu bottom left :max-height="'50vh'" :close-on-content-click="false">
                                  <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                      <v-icon>mdi-cogs</v-icon>
                                    </v-btn>
                                  </template>

                                  <v-list dense subheader>
                                    <v-subheader>Tip valoare</v-subheader>
                                    <v-list-tile @click="toggleCustomization(int, 'tip', 'executiela')">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="int.tipuriValori" value="executiela" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>Executie LA Trimestru</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click="toggleCustomization(int, 'tip', 'executiein')">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="int.tipuriValori" value="executiein" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>Executie IN Trimestru</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click="toggleCustomization(int, 'tip', 'y2yla')">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="int.tipuriValori" value="y2yla" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>Y2Y LA Trimestru</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click="toggleCustomization(int, 'tip', 'y2yin')">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="int.tipuriValori" value="y2yin" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>Y2Y IN Trimestru</v-list-tile-title>
                                    </v-list-tile>
                                    <v-divider></v-divider>
                                    <v-subheader>Perioada</v-subheader>
                                    <v-list-tile @click="toggleCustomization(int, 'perioada', p)" v-for="p in perioade" :key="p">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="int.perioade" :value="p" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>
                                        {{ p }}
                                      </v-list-tile-title>
                                    </v-list-tile>
                                  </v-list>
                                </v-menu>
                              </v-list-tile-action>
                            </v-list-tile>
                          </v-list>
                        </v-tab-item>
                        <v-tab-item key="std">
                          <v-list subheader dense two-line style="max-height: calc(50vh - 145px); height: 100%; overflow: auto; width: 100%">
                            <v-list-tile v-for="std in selectedIndicatoriStdepr" :key="'selected' + std._id">
                              <v-list-tile-action>
                                <v-btn icon @click="toggleIndicatoriStdeprSelection(std, -1)">
                                  <v-icon color="red">mdi-arrow-left-bold</v-icon>
                                </v-btn>
                              </v-list-tile-action>
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  {{ std.denumire }}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                  {{ std.cod }}
                                </v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <v-menu bottom left :max-height="'50vh'" :close-on-content-click="false">
                                  <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                      <v-icon>mdi-cogs</v-icon>
                                    </v-btn>
                                  </template>

                                  <v-list dense subheader>
                                    <v-subheader>Tip valoare</v-subheader>
                                    <v-list-tile @click="toggleCustomization(std, 'tip', 'executiela')">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="std.tipuriValori" value="executiela" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>Executie LA Trimestru</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click="toggleCustomization(std, 'tip', 'executiein')">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="std.tipuriValori" value="executiein" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>Executie IN Trimestru</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click="toggleCustomization(std, 'tip', 'y2yla')">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="std.tipuriValori" value="y2yla" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>Y2Y LA Trimestru</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click="toggleCustomization(std, 'tip', 'y2yin')">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="std.tipuriValori" value="y2yin" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>Y2Y IN Trimestru</v-list-tile-title>
                                    </v-list-tile>
                                    <v-divider></v-divider>
                                    <v-subheader>Perioada</v-subheader>
                                    <v-list-tile @click="toggleCustomization(std, 'perioada', p)" v-for="p in perioade" :key="p">
                                      <v-list-tile-action>
                                        <v-checkbox v-model="std.perioade" :value="p" @click.prevent>
                                        </v-checkbox>
                                      </v-list-tile-action>
                                      <v-list-tile-title>
                                        {{ p }}
                                      </v-list-tile-title>
                                    </v-list-tile>
                                  </v-list>
                                </v-menu>
                              </v-list-tile-action>
                            </v-list-tile>
                          </v-list>
                        </v-tab-item>
                      </v-tabs>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="5">
              <v-btn small color="primary" @click="finishDatasetCustomization" :disabled="!selectedCifuri.length || loadingData || loadingLabels">
                Genereaza raportul
                <v-icon right small>mdi-function</v-icon>
              </v-btn>
              <v-btn small color="accent" @click="exceller" :disabled="!selectedCifuri.length || loadingData || loadingLabels || !labelsRow.length">
                Exporta in XLS
                <v-icon right small>mdi-file-excel</v-icon>
              </v-btn>
              <v-text-field
                class="ml-2 d-inline-flex"
                append-icon="mdi-pencil"
                label="Denumire raport"
                v-model="reportName">
              </v-text-field>
              <v-btn small color="accent" @click="saveChoices" :disabled="!selectedCifuri.length || loadingData || loadingLabels">
                Salveaza configuratia
                <v-icon right small>mdi-database-plus</v-icon>
              </v-btn>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-flex>
      <v-flex style="flex-grow: 1; max-height: 200px; overflow-y: scroll; background-color: white" class="mt-1 elevation-4">
        <table width="100%" class="template-strings-table">
          <thead>
            <tr>
              <th class="caption font-weight-bold text-left">Categorie</th>
              <th class="caption font-weight-bold text-left">Denumire</th>
              <th class="caption font-weight-bold text-left">Cod</th>
              <th class="caption font-weight-bold text-left">Tip valoare</th>
              <th class="caption font-weight-bold text-left">Perioada</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="code in adminCodes"
              :key="code.cod">
              <td class="caption">{{ code.categorie }}</td>
              <td class="caption">{{ code.label }}</td>
              <td class="caption">{{ code.cod }}</td>
              <td class="caption">{{ code.tip }}</td>
              <td class="caption">{{ code.perioada }}</td>
            </tr>
          </tbody>
        </table>
      </v-flex>
      <v-flex style="flex-grow: 10; background-color: white" class="mt-1 elevation-4">
        <hot-table
          v-if="labelsRow.length"
          :data="hotData"
          :settings="hotSettings"
          style="width: 100%; height: 100%; overflow: hidden">
        </hot-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// pt cod economic alegem codul din clasificatia economica, apoi alegem ori total, ori un capitol functional (51, 55 etc.)
// codec comes before codfct
// codfc = prop from ecValues
// when codfct = c0000 => value is ecValues total <=> value
import translate from '@/mixins/Translate';
import { HotTable } from '@handsontable/vue';
require('numbro/dist/languages.min.js')

export default {
  name: 'rapoarte-interactive',
  components: {
    'hot-table': HotTable
  },
  mixins: [translate],
  data: () => ({
    type: 'interactive',
    loadingData: false,
    loadingLabels: false,
    reportName: 'Raport Interactiv',
    label: 'SectiuneInteractive_Titlu',
    wiz: 1,
    selectedTipRaport: 'liniar',
    perioade: [],
    selectedPerioada: null,
    selectedPerioadaId: null,
    cifuriProps: [],
    cifuriGrupate: [],
    selectedCifuri: [],
    selectedCifuriProps: ['denumire_apl', 'tip_apl', 'judet'],
    cifuriPage: 0,
    cifuriPerPage: 2,
    aplSearch: null,
    clasificatieTab: 0,
    clasificatieSearch: null,
    clasificatieVenituri: [],
    selectedVenituri: [],
    clasificatieChfct: [],
    selectedChfct: [],
    clasificatieChec: [],
    selectedChec: [],
    ecParents: [],
    venituriPage: 0,
    chfctPage: 0,
    checPage: 0,
    clasificatiePerPage: 10,

    indicatoriTab: 0,
    indicatoriSearch: null,
    indicatoriCheltuieli: [],
    indicatoriVenituri: [],
    indicatoriIntepr: [],
    indicatoriStdepr: [],
    selectedIndicatoriVenituri: [],
    selectedIndicatoriCheltuieli: [],
    selectedIndicatoriIntepr: [],
    selectedIndicatoriStdepr: [],
    indicatoriVenituriPage: 0,
    indicatoriCheltuieliPage: 0,
    indicatoriInteprPage: 0,
    indicatoriStdeprPage: 0,
    indicatoriPerPage: 10,

    labelsRow: [],
    dataRows: [],

    hotData: [],

    hotSettings: {
      rowHeaders: true,
      colHeaders: [],
      contextMenu: true,
      manualColumnResize: true,
      manualRowResize: true,
      manualColumnMove: true,
      manualRowMove: true,
      headerTooltips: true,
      stretchH: 'all',
      // columns: [
      //   { type: 'numeric' },
      //   { type: 'text' },
      //   { type: 'text' },
      //   { type: 'text' },
      //   { type: 'numeric', numericFormat: { pattern: '0,0.00', culture: 'de-DE' } },
      //   { type: 'numeric', numericFormat: { pattern: '0,0.00', culture: 'de-DE' } },
      //   { type: 'numeric', numericFormat: { pattern: '0,0.00', culture: 'de-DE' } },
      //   { type: 'numeric', numericFormat: { pattern: '0,0.00', culture: 'de-DE' } }
      // ],
      cells: function (row, column, prop) {
        // prop is equal to column when data is an array
        const cellProperties = {}

        if (column === 0) {
          cellProperties.type = 'numeric'
        } else if (column <= this.selectedCifuriProps) {
          cellProperties.type = 'text'
        } else {
          cellProperties.type = 'numeric'
          cellProperties.numericFormat = { pattern: '0,0.00', culture: 'de-DE' }
        }

        return cellProperties
      },
      multiColumnSorting: {
        sortEmptyCells: true,
        initialConfig: [{
          column: 1,
          sortOrder: 'asc'
        }, {
          column: 3,
          sortOrder: 'asc'
        }]
      },
      filters: true,
      dropdownMenu: true,
      licenseKey: 'non-commercial-and-evaluation',
      comments: true
    }
  }),
  computed: {
    host () {
      return this.$store.getters.host
    },
    loading () {
      return this.$store.getters[`${this.type}/loading`]
    },
    token () {
      return this.$store.getters['token']
    },
    user () {
      return this.$store.getters['user']
    },
    lang () {
      return this.$store.getters['dictionar/lang']
    },
    languages () {
      return this.$store.getters['dictionar/languages']
    },
    filteredCifuri () {
      const validCif = cif => cif.denumire_apl.toLowerCase().includes(this.aplSearch.trim().toLowerCase()) || cif.cif_op.trim().toLowerCase().includes(this.aplSearch.trim().toLowerCase())

      if (![null, undefined, ''].includes(typeof this.aplSearch === 'string' ? this.aplSearch.trim() : this.aplSearch)) {
        return this.cifuriGrupate.filter(judet => validCif(judet) || judet.children.some(cif => validCif(cif)))
      } else {
        return this.cifuriGrupate
      }
    },
    filteredVenituri () {
      if (![null, undefined, ''].includes(typeof this.clasificatieSearch === 'string' ? this.clasificatieSearch.trim() : this.clasificatieSearch)) {
        return this.clasificatieVenituri.filter(v => v.denumire.toLowerCase().includes(this.clasificatieSearch.toLowerCase()) || v.codec.toLowerCase().includes(this.clasificatieSearch.toLowerCase()))
      } else {
        return this.clasificatieVenituri
      }
    },
    filteredChfct () {
      if (![null, undefined, ''].includes(typeof this.clasificatieSearch === 'string' ? this.clasificatieSearch.trim() : this.clasificatieSearch)) {
        return this.clasificatieChfct.filter(v => v.denumire.toLowerCase().includes(this.clasificatieSearch.toLowerCase()) || v.codec.toLowerCase().includes(this.clasificatieSearch.toLowerCase()))
      } else {
        return this.clasificatieChfct
      }
    },
    filteredChec () {
      if (![null, undefined, ''].includes(typeof this.clasificatieSearch === 'string' ? this.clasificatieSearch.trim() : this.clasificatieSearch)) {
        return this.clasificatieChec.filter(v => v.denumire.toLowerCase().includes(this.clasificatieSearch.toLowerCase()) || v.codec.toLowerCase().includes(this.clasificatieSearch.toLowerCase()))
      } else {
        return this.clasificatieChec
      }
    },
    cifuriPages () {
      const labels = []
      for (let i = 0; i <= Math.ceil(this.filteredCifuri.length / this.cifuriPerPage); i++) {
        labels.push({
          value: i,
          text: this.filteredCifuri.slice(i * this.cifuriPerPage, (i + 1) * this.cifuriPerPage).reduce((acc, item) => {
            acc.push(item.judet)
            return acc
          }, []).join(', ')
        })
      }

      return labels.filter(label => label.text.length)
    },
    venituriPages () {
      const labels = []
      let page = 0
      let go = true
      while (go) {
        const slice = this.filteredVenituri.slice(page * this.clasificatiePerPage, (page + 1) * this.clasificatiePerPage)
        if (slice.length) {
          labels.push({
            value: page,
            text: `${slice.shift().codec} - ${slice.length ? slice.pop().codec : ''}`
          })
        } else {
          go = false
        }
        page++
      }
      return labels
    },
    chfctPages () {
      const labels = []
      let page = 0
      let go = true
      while (go) {
        const slice = this.filteredChfct.slice(page * this.clasificatiePerPage, (page + 1) * this.clasificatiePerPage)
        if (slice.length) {
          labels.push({
            value: page,
            text: `${slice.shift().codec} - ${slice.length ? slice.pop().codec : ''}`
          })
        } else {
          go = false
        }
        page++
      }
      return labels
    },
    checPages () {
      const labels = []
      let page = 0
      let go = true
      while (go) {
        const slice = this.filteredChec.slice(page * this.clasificatiePerPage, (page + 1) * this.clasificatiePerPage)
        if (slice.length) {
          labels.push({
            value: page,
            text: `${slice.shift().codec} - ${slice.length ? slice.pop().codec : ''}`
          })
        } else {
          go = false
        }
        page++
      }
      return labels
    },
    pagedCifuri () {
      return this.filteredCifuri.slice(this.cifuriPerPage * this.cifuriPage, this.cifuriPerPage * (this.cifuriPage + 1))
    },
    pagedVenituri () {
      return this.filteredVenituri.slice(this.clasificatiePerPage * this.venituriPage, this.clasificatiePerPage * (this.venituriPage + 1))
    },
    pagedChfct () {
      return this.filteredChfct.slice(this.clasificatiePerPage * this.chfctPage, this.clasificatiePerPage * (this.chfctPage + 1))
    },
    pagedChec () {
      return this.filteredChec.slice(this.clasificatiePerPage * this.checPage, this.clasificatiePerPage * (this.checPage + 1))
    },

    fileteredIndicatoriVenituri () {
      if (![null, undefined, ''].includes(typeof this.indicatoriSearch === 'string' ? this.indicatoriSearch.trim() : this.indicatoriSearch)) {
        return this.indicatoriVenituri.filter(v => v.denumire.toLowerCase().includes(this.indicatoriSearch.toLowerCase()) || v.cod.toLowerCase().includes(this.indicatoriSearch.toLowerCase()))
      } else {
        return this.indicatoriVenituri
      }
    },
    fileteredIndicatoriCheltuieli () {
      if (![null, undefined, ''].includes(typeof this.indicatoriSearch === 'string' ? this.indicatoriSearch.trim() : this.indicatoriSearch)) {
        return this.indicatoriCheltuieli.filter(v => v.denumire.toLowerCase().includes(this.indicatoriSearch.toLowerCase()) || v.cod.toLowerCase().includes(this.indicatoriSearch.toLowerCase()))
      } else {
        return this.indicatoriCheltuieli
      }
    },
    fileteredIndicatoriIntepr () {
      if (![null, undefined, ''].includes(typeof this.indicatoriSearch === 'string' ? this.indicatoriSearch.trim() : this.indicatoriSearch)) {
        return this.indicatoriIntepr.filter(v => v.denumire.toLowerCase().includes(this.indicatoriSearch.toLowerCase()) || v.cod.toLowerCase().includes(this.indicatoriSearch.toLowerCase()))
      } else {
        return this.indicatoriIntepr
      }
    },
    fileteredIndicatoriStdepr () {
      if (![null, undefined, ''].includes(typeof this.indicatoriSearch === 'string' ? this.indicatoriSearch.trim() : this.indicatoriSearch)) {
        return this.indicatoriStdepr.filter(v => v.denumire.toLowerCase().includes(this.indicatoriSearch.toLowerCase()) || v.cod.toLowerCase().includes(this.indicatoriSearch.toLowerCase()))
      } else {
        return this.indicatoriStdepr
      }
    },
    indicatoriVenituriPages () {
      const labels = []
      let page = 0
      let go = true
      while (go) {
        const slice = this.fileteredIndicatoriVenituri.slice(page * this.indicatoriPerPage, (page + 1) * this.indicatoriPerPage)
        if (slice.length) {
          labels.push({
            value: page,
            text: `${slice.shift().cod} - ${slice.length ? slice.pop().cod : ''}`
          })
        } else {
          go = false
        }
        page++
      }
      return labels
    },
    indicatoriCheltuieliPages () {
      const labels = []
      let page = 0
      let go = true
      while (go) {
        const slice = this.fileteredIndicatoriCheltuieli.slice(page * this.indicatoriPerPage, (page + 1) * this.indicatoriPerPage)
        if (slice.length) {
          labels.push({
            value: page,
            text: `${slice.shift().cod} - ${slice.length ? slice.pop().cod : ''}`
          })
        } else {
          go = false
        }
        page++
      }
      return labels
    },
    indicatoriInteprPages () {
      const labels = []
      let page = 0
      let go = true
      while (go) {
        const slice = this.fileteredIndicatoriIntepr.slice(page * this.indicatoriPerPage, (page + 1) * this.indicatoriPerPage)
        if (slice.length) {
          labels.push({
            value: page,
            text: `${slice.shift().cod} - ${slice.length ? slice.pop().cod : ''}`
          })
        } else {
          go = false
        }
        page++
      }
      return labels
    },
    indicatoriStdeprPages () {
      const labels = []
      let page = 0
      let go = true
      while (go) {
        const slice = this.fileteredIndicatoriStdepr.slice(page * this.indicatoriPerPage, (page + 1) * this.indicatoriPerPage)
        if (slice.length) {
          labels.push({
            value: page,
            text: `${slice.shift().cod} - ${slice.length ? slice.pop().cod : ''}`
          })
        } else {
          go = false
        }
        page++
      }
      return labels
    },
    pagedIndicatoriVenituri () {
      return this.fileteredIndicatoriVenituri.slice(this.indicatoriPerPage * this.indicatoriVenituriPage, this.indicatoriPerPage * (this.indicatoriVenituriPage + 1))
    },
    pagedIndicatoriCheltuieli () {
      return this.fileteredIndicatoriCheltuieli.slice(this.indicatoriPerPage * this.indicatoriCheltuieliPage, this.indicatoriPerPage * (this.indicatoriCheltuieliPage + 1))
    },
    pagedIndicatoriIntepr () {
      return this.fileteredIndicatoriIntepr.slice(this.indicatoriPerPage * this.indicatoriInteprPage, this.indicatoriPerPage * (this.indicatoriInteprPage + 1))
    },
    pagedIndicatoriStdepr () {
      return this.fileteredIndicatoriStdepr.slice(this.indicatoriPerPage * this.indicatoriStdeprPage, this.indicatoriPerPage * (this.indicatoriStdeprPage + 1))
    },

    formattedCifuri () {
      // K!prop_tr_an_cif
      const getType = type => {
        switch (type.toLowerCase()) {
          case 'apl-urile': {
            return 'all'
          }
          case 'judetele': {
            return 'Judet'
          }
          case 'municipiile': {
            return 'Municipiu'
          }
          case 'orasele': {
            return 'Oras'
          }
          case 'comunele': {
            return 'Comuna'
          }
        }
      }
      const cifuri = []
      this.selectedCifuri.forEach(cif => {
        if (cif.cif_op.startsWith('toate')) {
          if (cif.cif_op.includes('din')) {
            const parts = cif.cif_op.split(' ')
            const parentCif = parts.pop()
            const aplType = getType(parts[1])
            const judet = this.cifuriGrupate.find(j => j.cif_op === parentCif)

            if (aplType === 'all') {
              // cifuri.push(judet.cif_op + judet.denumire_apl)
              cifuri.push(...judet.children.filter(c => c.tip_apl !== 'R').map(c => c.cif_op))
            } else {
              cifuri.push(...judet.children.filter(c => c.tip_apl !== 'R' && c.tip_apl === aplType).map(c => c.cif_op))
            }
          } else {
            const parts = cif.cif_op.split(' ')
            const aplType = getType(parts[1])

            if (aplType === 'all') {
              this.cifuriGrupate.forEach(judet => {
                // cifuri.push(judet.cif_op)
                judet.children.forEach(c => {
                  if (c.tip_apl !== 'R') {
                    cifuri.push(c.cif_op)
                  }
                })
              })
            } else if (aplType === 'Judet') {
              this.cifuriGrupate.forEach(judet => {
                if (judet.tip_apl === 'Judet') cifuri.push(judet.cif_op)
              })
            } else {
              this.cifuriGrupate.forEach(judet => {
                judet.children.forEach(c => {
                  if (c.tip_apl === aplType) {
                    cifuri.push(c.cif_op)
                  }
                })
              })
            }
          }
        } else {
          cifuri.push(cif.cif_op)
        }
      })

      return cifuri
    },
    formattedProps () {
      // K!prop_tr_an_cif

      const coduri = []
      const perioadaParts = this.selectedPerioada ? this.selectedPerioada.split('-') : [null, null]
      const an = perioadaParts[0]
      const tr = perioadaParts[1]

      this.selectedCifuriProps.forEach(prop => {
        coduri.push(`K!${prop.replace('_', '-')}_${tr}_${an}`)
      })

      return coduri
    },
    formattedClasificatieVenituri () {
      // C!Ven_Set1_c0001_A_ExeLa_timestru_an_cif
      const getTipValoare = tip => {
        switch (tip) {
          case 'executiela': return 'ExeLa'
          case 'executiein': return 'ExeIn'
          case 'y2yla': return 'Y2YLa'
          case 'y2yin': return 'Y2YIn'
        }
      }

      const coduri = []
      this.selectedVenituri.forEach(venit => {
        venit.tipuriValori.forEach(tipRaw => {
          const tip = getTipValoare(tipRaw)
          venit.perioade.forEach(perioada => {
            const parts = perioada.split('-')
            const an = parts[0]
            const tr = parts[1]

            coduri.push(`C!Ven_${venit.set}_${venit.cod}_A_${tip}_${tr}_${an}`)
          })
        })
      })

      return coduri
    },
    formattedClasificatieChfct () {
      // C!Fct_Set1_c510000_A_ExeIn_timestru_an_cif
      const getTipValoare = tip => {
        switch (tip) {
          case 'executiela': return 'ExeLa'
          case 'executiein': return 'ExeIn'
          case 'y2yla': return 'Y2YLa'
          case 'y2yin': return 'Y2YIn'
        }
      }

      const coduri = []
      this.selectedChfct.forEach(fct => {
        fct.tipuriValori.forEach(tipRaw => {
          const tip = getTipValoare(tipRaw)
          fct.perioade.forEach(perioada => {
            const parts = perioada.split('-')
            const an = parts[0]
            const tr = parts[1]

            coduri.push(`C!Fct_${fct.set}_${fct.cod}_A_${tip}_${tr}_${an}`)
          })
        })
      })

      return coduri
    },
    formattedClasificatieChec () {
      // C!Ec_Set3_cOp_c0000_A_ExeLa_Tn_1_cif
      const getTipValoare = tip => {
        switch (tip) {
          case 'executiela': return 'ExeLa'
          case 'executiein': return 'ExeIn'
          case 'y2yla': return 'Y2YLa'
          case 'y2yin': return 'Y2YIn'
        }
      }

      const coduri = []
      this.selectedChec.forEach(ec => {
        ec.tipuriValori.forEach(tipRaw => {
          const tip = getTipValoare(tipRaw)
          ec.perioade.forEach(perioada => {
            const parts = perioada.split('-')
            const an = parts[0]
            const tr = parts[1]

            ec.codfct.forEach(fct => {
              coduri.push(`C!Ec_${ec.set}_${ec.cod}_${fct}_A_${tip}_${tr}_${an}`)
            })
          })
        })
      })

      return coduri
    },
    formattedIndicatoriVenituri () {
      // I!cod_tab_trimestru_an

      // venstdla
      // venstdin
      // chstdla
      // chstdin
      // inteprexela
      // inteprexein
      // intepry2yla
      // intepry2yin
      // stdeprexela
      // stdepry2yin
      // stdeprexein
      // stdepry2yla

      const getTab = (tab, tip) => {
        switch (tab) {
          case 'venstdla': {
            return tip.endsWith('la') ? 'venstdla' : 'venstdin'
          }
          case 'chstdla': {
            return tip.endsWith('la') ? 'chstdla' : 'chstdin'
          }
          case 'inteprexela': {
            if (tip.startsWith('y2y')) {
              return tip.endsWith('la') ? 'intepry2yla' : 'intepry2yin'
            } else {
              return tip.endsWith('la') ? 'inteprexela' : 'inteprexein'
            }
          }
          case 'stdeprexela': {
            if (tip.startsWith('y2y')) {
              return tip.endsWith('la') ? 'stdepry2yla' : 'stdepry2yin'
            } else {
              return tip.endsWith('la') ? 'stdeprexela' : 'stdeprexein'
            }
          }
        }
      }

      const coduri = []
      this.selectedIndicatoriVenituri.forEach(venit => {
        venit.tipuriValori.forEach(tipRaw => {
          venit.perioade.forEach(perioada => {
            const parts = perioada.split('-')
            const an = parts[0]
            const tr = parts[1]

            coduri.push(`I!${venit.cod}_${getTab(venit.tab, tipRaw)}_${tr}_${an}`)
          })
        })
      })

      return coduri
    },
    formattedIndicatoriCheltuieli () {
      // I!cod_tab_trimestru_an
      const getTab = (tab, tip) => {
        switch (tab) {
          case 'venstdla': {
            return tip.endsWith('la') ? 'venstdla' : 'venstdin'
          }
          case 'chstdla': {
            return tip.endsWith('la') ? 'chstdla' : 'chstdin'
          }
          case 'inteprexela': {
            if (tip.startsWith('y2y')) {
              return tip.endsWith('la') ? 'intepry2yla' : 'intepry2yin'
            } else {
              return tip.endsWith('la') ? 'inteprexela' : 'inteprexein'
            }
          }
          case 'stdeprexela': {
            if (tip.startsWith('y2y')) {
              return tip.endsWith('la') ? 'stdepry2yla' : 'stdepry2yin'
            } else {
              return tip.endsWith('la') ? 'stdeprexela' : 'stdeprexein'
            }
          }
        }
      }

      const coduri = []
      this.selectedIndicatoriCheltuieli.forEach(ch => {
        ch.tipuriValori.forEach(tipRaw => {
          ch.perioade.forEach(perioada => {
            const parts = perioada.split('-')
            const an = parts[0]
            const tr = parts[1]

            coduri.push(`I!${ch.cod}_${getTab(ch.tab, tipRaw)}_${tr}_${an}`)
          })
        })
      })

      return coduri
    },
    formattedIndicatoriIntepr () {
      // I!cod_tab_trimestru_an
      const getTab = (tab, tip) => {
        switch (tab) {
          case 'venstdla': {
            return tip.endsWith('la') ? 'venstdla' : 'venstdin'
          }
          case 'chstdla': {
            return tip.endsWith('la') ? 'chstdla' : 'chstdin'
          }
          case 'inteprexela': {
            if (tip.startsWith('y2y')) {
              return tip.endsWith('la') ? 'intepry2yla' : 'intepry2yin'
            } else {
              return tip.endsWith('la') ? 'inteprexela' : 'inteprexein'
            }
          }
          case 'stdeprexela': {
            if (tip.startsWith('y2y')) {
              return tip.endsWith('la') ? 'stdepry2yla' : 'stdepry2yin'
            } else {
              return tip.endsWith('la') ? 'stdeprexela' : 'stdeprexein'
            }
          }
        }
      }

      const coduri = []
      this.selectedIndicatoriIntepr.forEach(intepr => {
        intepr.tipuriValori.forEach(tipRaw => {
          intepr.perioade.forEach(perioada => {
            const parts = perioada.split('-')
            const an = parts[0]
            const tr = parts[1]

            coduri.push(`I!${intepr.cod}_${getTab(intepr.tab, tipRaw)}_${tr}_${an}`)
          })
        })
      })

      return coduri
    },
    formattedIndicatoriStdepr () {
      // I!cod_tab_trimestru_an
      const getTab = (tab, tip) => {
        switch (tab) {
          case 'venstdla': {
            return tip.endsWith('la') ? 'venstdla' : 'venstdin'
          }
          case 'chstdla': {
            return tip.endsWith('la') ? 'chstdla' : 'chstdin'
          }
          case 'inteprexela': {
            if (tip.startsWith('y2y')) {
              return tip.endsWith('la') ? 'intepry2yla' : 'intepry2yin'
            } else {
              return tip.endsWith('la') ? 'inteprexela' : 'inteprexein'
            }
          }
          case 'stdeprexela': {
            if (tip.startsWith('y2y')) {
              return tip.endsWith('la') ? 'stdepry2yla' : 'stdepry2yin'
            } else {
              return tip.endsWith('la') ? 'stdeprexela' : 'stdeprexein'
            }
          }
        }
      }

      const coduri = []
      this.selectedIndicatoriStdepr.forEach(stdepr => {
        stdepr.tipuriValori.forEach(tipRaw => {
          stdepr.perioade.forEach(perioada => {
            const parts = perioada.split('-')
            const an = parts[0]
            const tr = parts[1]

            coduri.push(`I!${stdepr.cod}_${getTab(stdepr.tab, tipRaw)}_${tr}_${an}`)
          })
        })
      })

      return coduri
    },

    totalSelectedClasificatie () {
      // return `${this.formattedClasificatieVenituri.length} Venituri, ${this.formattedClasificatieChfct.length} Cheltuieli Functionale, ${this.formattedClasificatieChec.length} Cheltuieli Economice`
      // return `${this.formattedClasificatieVenituri.length} Ven, ${this.formattedClasificatieChfct.length} Fct, ${this.formattedClasificatieChec.length} Ec`
      return this.formattedClasificatieVenituri.length + this.formattedClasificatieChfct.length + this.formattedClasificatieChec.length
    },
    totalSelectedIndicatori () {
      // return `${this.formattedIndicatoriVenituri.length} Venituri, ${this.formattedIndicatoriCheltuieli.length} Cheltuieli, ${this.formattedIndicatoriIntepr.length} Modelare Int, ${this.formattedIndicatoriStdepr.length} Modelare Std`
      // return `${this.formattedIndicatoriVenituri.length} Ven, ${this.formattedIndicatoriCheltuieli.length} Ch, ${this.formattedIndicatoriIntepr.length} Int, ${this.formattedIndicatoriStdepr.length} Std`
      return this.formattedIndicatoriVenituri.length + this.formattedIndicatoriCheltuieli.length + this.formattedIndicatoriIntepr.length + this.formattedIndicatoriStdepr.length
    },

    adminCodesCVen () {
      // C!Ven_Set1_c0001_A_ExeLa_timestru_an_cif
      const getTipValoare = tip => {
        switch (tip) {
          case 'executiela': return 'ExeLa'
          case 'executiein': return 'ExeIn'
          case 'y2yla': return 'Y2YLa'
          case 'y2yin': return 'Y2YIn'
        }
      }

      const coduri = []
      this.selectedVenituri.forEach(venit => {
        venit.tipuriValori.forEach(tipRaw => {
          const tip = getTipValoare(tipRaw)
          venit.perioade.forEach(perioada => {
            const parts = perioada.split('-')
            const an = parts[0]
            const tr = parts[1]

            coduri.push({
              label: venit.denumire,
              tip: tipRaw,
              perioada,
              cod: `C!Ven_${venit.set}_${venit.cod}_A_${tip}_${tr}_${an}`
            })
          })
        })
      })

      return coduri
    },
    adminCodesCFct () {
      // C!Fct_Set1_c510000_A_ExeIn_timestru_an_cif
      const getTipValoare = tip => {
        switch (tip) {
          case 'executiela': return 'ExeLa'
          case 'executiein': return 'ExeIn'
          case 'y2yla': return 'Y2YLa'
          case 'y2yin': return 'Y2YIn'
        }
      }

      const coduri = []
      this.selectedChfct.forEach(fct => {
        fct.tipuriValori.forEach(tipRaw => {
          const tip = getTipValoare(tipRaw)
          fct.perioade.forEach(perioada => {
            const parts = perioada.split('-')
            const an = parts[0]
            const tr = parts[1]

            coduri.push({
              label: fct.denumire,
              tip: tipRaw,
              perioada,
              cod: `C!Fct_${fct.set}_${fct.cod}_A_${tip}_${tr}_${an}`
            })
          })
        })
      })

      return coduri
    },
    adminCodesCEc () {
      // C!Ec_Set3_cOp_c0000_A_ExeLa_Tn_1_cif
      const getTipValoare = tip => {
        switch (tip) {
          case 'executiela': return 'ExeLa'
          case 'executiein': return 'ExeIn'
          case 'y2yla': return 'Y2YLa'
          case 'y2yin': return 'Y2YIn'
        }
      }

      const coduri = []
      this.selectedChec.forEach(ec => {
        ec.tipuriValori.forEach(tipRaw => {
          const tip = getTipValoare(tipRaw)
          ec.perioade.forEach(perioada => {
            const parts = perioada.split('-')
            const an = parts[0]
            const tr = parts[1]

            ec.codfct.forEach(fct => {
              coduri.push({
                label: ec.denumire,
                tip: tipRaw,
                perioada,
                cod: `C!Ec_${ec.set}_${ec.cod}_${fct}_A_${tip}_${tr}_${an}`
              })
            })
          })
        })
      })

      return coduri
    },
    adminCodesIVen () {
      // I!cod_tab_trimestru_an

      // venstdla
      // venstdin
      // chstdla
      // chstdin
      // inteprexela
      // inteprexein
      // intepry2yla
      // intepry2yin
      // stdeprexela
      // stdepry2yin
      // stdeprexein
      // stdepry2yla

      const getTab = (tab, tip) => {
        switch (tab) {
          case 'venstdla': {
            return tip.endsWith('la') ? 'venstdla' : 'venstdin'
          }
          case 'chstdla': {
            return tip.endsWith('la') ? 'chstdla' : 'chstdin'
          }
          case 'inteprexela': {
            if (tip.startsWith('y2y')) {
              return tip.endsWith('la') ? 'intepry2yla' : 'intepry2yin'
            } else {
              return tip.endsWith('la') ? 'inteprexela' : 'inteprexein'
            }
          }
          case 'stdeprexela': {
            if (tip.startsWith('y2y')) {
              return tip.endsWith('la') ? 'stdepry2yla' : 'stdepry2yin'
            } else {
              return tip.endsWith('la') ? 'stdeprexela' : 'stdeprexein'
            }
          }
        }
      }

      const coduri = []
      this.selectedIndicatoriVenituri.forEach(venit => {
        venit.tipuriValori.forEach(tipRaw => {
          venit.perioade.forEach(perioada => {
            const parts = perioada.split('-')
            const an = parts[0]
            const tr = parts[1]

            coduri.push({
              label: venit.denumire,
              tip: tipRaw,
              perioada,
              cod: `I!${venit.cod}_${getTab(venit.tab, tipRaw)}_${tr}_${an}`
            })
          })
        })
      })

      return coduri
    },
    adminCodesICh () {
      // I!cod_tab_trimestru_an
      const getTab = (tab, tip) => {
        switch (tab) {
          case 'venstdla': {
            return tip.endsWith('la') ? 'venstdla' : 'venstdin'
          }
          case 'chstdla': {
            return tip.endsWith('la') ? 'chstdla' : 'chstdin'
          }
          case 'inteprexela': {
            if (tip.startsWith('y2y')) {
              return tip.endsWith('la') ? 'intepry2yla' : 'intepry2yin'
            } else {
              return tip.endsWith('la') ? 'inteprexela' : 'inteprexein'
            }
          }
          case 'stdeprexela': {
            if (tip.startsWith('y2y')) {
              return tip.endsWith('la') ? 'stdepry2yla' : 'stdepry2yin'
            } else {
              return tip.endsWith('la') ? 'stdeprexela' : 'stdeprexein'
            }
          }
        }
      }

      const coduri = []
      this.selectedIndicatoriCheltuieli.forEach(ch => {
        ch.tipuriValori.forEach(tipRaw => {
          ch.perioade.forEach(perioada => {
            const parts = perioada.split('-')
            const an = parts[0]
            const tr = parts[1]

            coduri.push({
              label: ch.denumire,
              tip: tipRaw,
              perioada,
              cod: `I!${ch.cod}_${getTab(ch.tab, tipRaw)}_${tr}_${an}`
            })
          })
        })
      })

      return coduri
    },
    adminCodesIInt () {
      // I!cod_tab_trimestru_an
      const getTab = (tab, tip) => {
        switch (tab) {
          case 'venstdla': {
            return tip.endsWith('la') ? 'venstdla' : 'venstdin'
          }
          case 'chstdla': {
            return tip.endsWith('la') ? 'chstdla' : 'chstdin'
          }
          case 'inteprexela': {
            if (tip.startsWith('y2y')) {
              return tip.endsWith('la') ? 'intepry2yla' : 'intepry2yin'
            } else {
              return tip.endsWith('la') ? 'inteprexela' : 'inteprexein'
            }
          }
          case 'stdeprexela': {
            if (tip.startsWith('y2y')) {
              return tip.endsWith('la') ? 'stdepry2yla' : 'stdepry2yin'
            } else {
              return tip.endsWith('la') ? 'stdeprexela' : 'stdeprexein'
            }
          }
        }
      }

      const coduri = []
      this.selectedIndicatoriIntepr.forEach(intepr => {
        intepr.tipuriValori.forEach(tipRaw => {
          intepr.perioade.forEach(perioada => {
            const parts = perioada.split('-')
            const an = parts[0]
            const tr = parts[1]

            coduri.push({
              label: intepr.denumire,
              tip: tipRaw,
              perioada,
              cod: `I!${intepr.cod}_${getTab(intepr.tab, tipRaw)}_${tr}_${an}`
            })
          })
        })
      })

      return coduri
    },
    adminCodesIStd () {
      // I!cod_tab_trimestru_an
      const getTab = (tab, tip) => {
        switch (tab) {
          case 'venstdla': {
            return tip.endsWith('la') ? 'venstdla' : 'venstdin'
          }
          case 'chstdla': {
            return tip.endsWith('la') ? 'chstdla' : 'chstdin'
          }
          case 'inteprexela': {
            if (tip.startsWith('y2y')) {
              return tip.endsWith('la') ? 'intepry2yla' : 'intepry2yin'
            } else {
              return tip.endsWith('la') ? 'inteprexela' : 'inteprexein'
            }
          }
          case 'stdeprexela': {
            if (tip.startsWith('y2y')) {
              return tip.endsWith('la') ? 'stdepry2yla' : 'stdepry2yin'
            } else {
              return tip.endsWith('la') ? 'stdeprexela' : 'stdeprexein'
            }
          }
        }
      }

      const coduri = []
      this.selectedIndicatoriStdepr.forEach(stdepr => {
        stdepr.tipuriValori.forEach(tipRaw => {
          stdepr.perioade.forEach(perioada => {
            const parts = perioada.split('-')
            const an = parts[0]
            const tr = parts[1]

            coduri.push({
              label: stdepr.denumire,
              tip: tipRaw,
              perioada,
              cod: `I!${stdepr.cod}_${getTab(stdepr.tab, tipRaw)}_${tr}_${an}`
            })
          })
        })
      })

      return coduri
    },

    adminCodes () {
      return [
        ...this.adminCodesCVen.map(item => ({ ...item, categorie: 'Clasif. Venituri' })),
        ...this.adminCodesCFct.map(item => ({ ...item, categorie: 'Clasif. Ch. Fct.' })),
        ...this.adminCodesCEc.map(item => ({ ...item, categorie: 'Clasif. Ch. Ecn.' })),
        ...this.adminCodesIVen.map(item => ({ ...item, categorie: 'Indicatori Ven.' })),
        ...this.adminCodesICh.map(item => ({ ...item, categorie: 'Indicatori Ch.' })),
        ...this.adminCodesIInt.map(item => ({ ...item, categorie: 'Indicatori Int' })),
        ...this.adminCodesIStd.map(item => ({ ...item, categorie: 'Indicatori Std' }))
      ]
    }
  },
  methods: {
    saveChoices () {
      // save in db
    },

    toggleCifSelection (cif, mode) {
      if (mode === 1) {
        this.selectedCifuri.push({ ...cif, props: this.selectedCifuriProps })
        const judet = this.cifuriGrupate.find(c => c.judet === cif.judet)
        const apl = judet.children.find(c => c.cif_op === cif.cif_op)
        apl.disabled = true
      } else {
        const selectedIndex = this.selectedCifuri.findIndex(c => c.cif_op === cif.cif_op)
        this.selectedCifuri.splice(selectedIndex, 1)
        const judet = this.cifuriGrupate.find(c => c.judet === cif.judet)
        const apl = judet.children.find(c => c.cif_op === cif.cif_op)
        apl.disabled = false
      }
    },
    highlightCif (cif) {
      if ([null, undefined, ''].includes(typeof this.aplSearch === 'string' ? this.aplSearch.trim() : this.aplSearch)) return 'undefined'
      else if (cif.denumire_apl.toLowerCase().includes(this.aplSearch.trim().toLowerCase()) || cif.cif_op.trim().toLowerCase().includes(this.aplSearch.trim().toLowerCase())) {
        return 'accent'
      }
      return 'undefined'
    },
    toggleVenitSelection (venit, mode) {
      if (mode === 1) {
        const item = this.clasificatieVenituri.find(v => v._id === venit._id)
        item.disabled = true
        this.selectedVenituri.push({ ...venit, tipuriValori: ['executiela'], perioade: [this.selectedPerioada] })
      } else {
        const item = this.clasificatieVenituri.find(v => v._id === venit._id)
        item.disabled = false
        const selectedIndex = this.selectedVenituri.findIndex(v => v._id === venit._id)
        this.selectedVenituri.splice(selectedIndex, 1)
      }
    },
    toggleChfctSelection (chfct, mode) {
      if (mode === 1) {
        const item = this.clasificatieChfct.find(v => v._id === chfct._id)
        item.disabled = true
        this.selectedChfct.push({ ...chfct, tipuriValori: ['executiela'], perioade: [this.selectedPerioada] })
      } else {
        const item = this.clasificatieChfct.find(v => v._id === chfct._id)
        item.disabled = false
        const selectedIndex = this.selectedChfct.findIndex(v => v._id === chfct._id)
        this.selectedChfct.splice(selectedIndex, 1)
      }
    },
    toggleChecSelection (chec, mode) {
      if (mode === 1) {
        const item = this.clasificatieChec.find(v => v._id === chec._id)
        item.disabled = true
        this.selectedChec.push({ ...chec, tipuriValori: ['executiela'], perioade: [this.selectedPerioada], codfct: ['c0000'] })
      } else {
        const item = this.clasificatieChec.find(v => v._id === chec._id)
        item.disabled = false
        const selectedIndex = this.selectedChec.findIndex(v => v._id === chec._id)
        this.selectedChec.splice(selectedIndex, 1)
      }
    },

    toggleIndicatoriVenitSelection (venit, mode) {
      if (mode === 1) {
        const item = this.indicatoriVenituri.find(v => v._id === venit._id)
        item.disabled = true
        this.selectedIndicatoriVenituri.push({ ...venit, tipuriValori: ['executiela'], perioade: [this.selectedPerioada] })
      } else {
        const item = this.indicatoriVenituri.find(v => v._id === venit._id)
        item.disabled = false
        const selectedIndex = this.selectedIndicatoriVenituri.findIndex(v => v._id === venit._id)
        this.selectedIndicatoriVenituri.splice(selectedIndex, 1)
      }
    },
    toggleIndicatoriCheltuialaSelection (venit, mode) {
      if (mode === 1) {
        const item = this.indicatoriCheltuieli.find(v => v._id === venit._id)
        item.disabled = true
        this.selectedIndicatoriCheltuieli.push({ ...venit, tipuriValori: ['executiela'], perioade: [this.selectedPerioada] })
      } else {
        const item = this.indicatoriCheltuieli.find(v => v._id === venit._id)
        item.disabled = false
        const selectedIndex = this.selectedIndicatoriCheltuieli.findIndex(v => v._id === venit._id)
        this.selectedIndicatoriCheltuieli.splice(selectedIndex, 1)
      }
    },
    toggleIndicatoriInteprSelection (venit, mode) {
      if (mode === 1) {
        const item = this.indicatoriIntepr.find(v => v._id === venit._id)
        item.disabled = true
        this.selectedIndicatoriIntepr.push({ ...venit, tipuriValori: ['executiela'], perioade: [this.selectedPerioada] })
      } else {
        const item = this.indicatoriIntepr.find(v => v._id === venit._id)
        item.disabled = false
        const selectedIndex = this.selectedIndicatoriIntepr.findIndex(v => v._id === venit._id)
        this.selectedIndicatoriIntepr.splice(selectedIndex, 1)
      }
    },
    toggleIndicatoriStdeprSelection (venit, mode) {
      if (mode === 1) {
        const item = this.indicatoriStdepr.find(v => v._id === venit._id)
        item.disabled = true
        this.selectedIndicatoriStdepr.push({ ...venit, tipuriValori: ['executiela'], perioade: [this.selectedPerioada] })
      } else {
        const item = this.indicatoriStdepr.find(v => v._id === venit._id)
        item.disabled = false
        const selectedIndex = this.selectedIndicatoriStdepr.findIndex(v => v._id === venit._id)
        this.selectedIndicatoriStdepr.splice(selectedIndex, 1)
      }
    },

    toggleCustomization (item, prop, value) {
      switch (prop) {
        case 'tip': {
          const index = item.tipuriValori.findIndex(t => t === value)
          if (index === -1) {
            item.tipuriValori.push(value)
          } else {
            item.tipuriValori.splice(index, 1)
          }
          break
        }
        case 'perioada': {
          const index = item.perioade.findIndex(p => p === value)
          if (index === -1) {
            item.perioade.push(value)
          } else {
            item.perioade.splice(index, 1)
          }
          break
        }
        case 'codfct': {
          const index = item.codfct.findIndex(c => c === value)
          if (index === -1) {
            item.codfct.push(value)
          } else {
            item.codfct.splice(index, 1)
          }
          break
        }
        case 'prop': {
          const index = this.selectedCifuriProps.findIndex(p => p === value)
          if (index === -1) {
            this.selectedCifuriProps.push(value)
          } else {
            this.selectedCifuriProps.splice(index, 1)
          }
          break
        }
      }
    },

    async getCifuri () {
      const headers = new Headers({
        'Content-Type': 'application/json',
        'Authorization': this.token
      })

      try {
        const perioadeResponse = await fetch(`${this.host}/cifuriperioade?$sort[label]=-1&$paginate&$select[]=label`, {
          method: 'get',
          headers
        })
        const perioade = await perioadeResponse.json()
        this.perioade = perioade.map(p => p.label)
        this.selectedPerioada = this.perioade[0]
        this.selectedPerioadaId = perioade[0]._id

        const cifuriHeadersResponse = await fetch(`${this.host}/cifuriheaders?$paginate=false&$select=value&$select=meaning&perioada=${perioade[0]._id}&$sort[value]=1`, {
          method: 'get',
          headers
        })
        const cifuriHeaders = await cifuriHeadersResponse.json()

        this.cifuriProps = cifuriHeaders.filter(h => !['_id', 'createdAt', 'updatedAt', 'computed', 'verificare', 'prioritate'].includes(h.value))

        const cifuriResponse = await fetch(`${this.host}/cifuri?perioada=${perioade[0]._id}&$paginate&$select=denumire_apl&$select=tip_apl&$select=judet&$select=cif_op&$sort[denumire_apl]=1`, {
          method: 'get',
          headers
        })
        const cifuri = await cifuriResponse.json()
        cifuri.sort((a, b) => {
          if (a.tip_apl === 'Judet' && b.tip_apl !== 'Judet') return -1
          if (a.tip_apl !== 'Judet' && b.tip_apl === 'Judet') return 1
          return 0
        })
        this.cifuri = cifuri.map(c => {
          if (c.tip_apl === 'Comuna') {
            c.denumire_apl = 'Comuna ' + c.denumire_apl
          }

          return c
        })

        const grouped = [{
          cif_op: '0',
          denumire_apl: 'SELECTIE RAPIDA',
          judet: 'SELECTIE RAPIDA',
          tip_apl: 'R',
          municipii: [{
            cif_op: 'toate apl-urile',
            denumire_apl: 'Toate APL-urile',
            judet: 'SELECTIE RAPIDA',
            tip_apl: 'R',
            disabled: false
          }, {
            cif_op: 'toate judetele',
            denumire_apl: 'Toate Judetele',
            judet: 'SELECTIE RAPIDA',
            tip_apl: 'R',
            disabled: false
          }, {
            cif_op: 'toate municipiile',
            denumire_apl: 'Toate municipiile',
            judet: 'SELECTIE RAPIDA',
            tip_apl: 'R',
            disabled: false
          }, {
            cif_op: 'toate orasele',
            denumire_apl: 'Toate orasele',
            judet: 'SELECTIE RAPIDA',
            tip_apl: 'R',
            disabled: false
          }, {
            cif_op: 'toate comunele',
            denumire_apl: 'Toate comunele',
            judet: 'SELECTIE RAPIDA',
            tip_apl: 'R',
            disabled: false
          }],
          orase: [],
          comune: []
        }]

        cifuri.forEach(cif => {
          switch (cif.tip_apl) {
            case 'Judet': {
              grouped.push({
                ...cif,
                municipii: [{
                  cif_op: 'toate apl-urile din ' + cif.cif_op,
                  denumire_apl: 'Toate apl-urile din ' + cif.denumire_apl,
                  judet: cif.judet,
                  tip_apl: 'R',
                  disabled: false
                }, {
                  cif_op: 'toate municipiile din ' + cif.cif_op,
                  denumire_apl: 'Toate municipiile din ' + cif.denumire_apl,
                  judet: cif.judet,
                  tip_apl: 'R',
                  disabled: false
                }, {
                  cif_op: 'toate orasele din ' + cif.cif_op,
                  denumire_apl: 'Toate orasele din ' + cif.denumire_apl,
                  judet: cif.judet,
                  tip_apl: 'R',
                  disabled: false
                }, {
                  cif_op: 'toate comunele din ' + cif.cif_op,
                  denumire_apl: 'Toate comunele din ' + cif.denumire_apl,
                  judet: cif.judet,
                  tip_apl: 'R',
                  disabled: false
                },
                {
                  ...cif,
                  disabled: false
                }],
                orase: [],
                comune: []
              })
              break
            }
            case 'Municipiu': {
              if (cif.denumire_apl === 'Municipiul Bucuresti') {
                grouped.push({
                  ...cif,
                  municipii: [{
                    ...cif,
                    disabled: false
                  }],
                  orase: [],
                  comune: []
                })
              } else {
                const parent = grouped.find(j => j.judet === cif.judet)
                parent.municipii.push({ ...cif, disabled: false })
              }
              break
            }
            case 'Oras': {
              const parent = grouped.find(j => j.judet === cif.judet)
              parent.orase.push({ ...cif, disabled: false })
              break
            }
            case 'Comuna': {
              const parent = grouped.find(j => j.judet === cif.judet)
              parent.comune.push({ ...cif, disabled: false })
              break
            }
          }
        })

        grouped.forEach(judet => {
          judet.children = judet.municipii.concat(judet.orase).concat(judet.comune)
          delete judet.municipii
          delete judet.orase
          delete judet.comune
        })

        this.cifuriGrupate = grouped
      } catch (err) {
        console.log(err)
      }
    },
    async getClasificatie () {
      const headers = new Headers({
        'Content-Type': 'application/json',
        'Authorization': this.token
      })

      try {
        const venituriResponse = await fetch(`${this.host}/clasificatie?$paginate=false&perioada=${this.selectedPerioadaId}&tab=venituri&$select=denumire&$select=codec&$select=cod&$select=tab&$sort[index]=1&set1[$ne]=xx`, {
          method: 'get',
          headers
        })
        const venituri = await venituriResponse.json()
        this.clasificatieVenituri = [
          {
            '_id': '49.90',
            'codec': '49.90',
            'cod': 'c4990',
            'denumire': 'Venituri Proprii',
            'tab': 'venituri',
            'set': 'cSet2'
          },
          {
            '_id': 'otvp',
            'codec': 'OT VP',
            'cod': 'cOTVP',
            'denumire': 'OT VP',
            'tab': 'venituri',
            'set': 'cSet2'
          },
          {
            '_id': 'sf',
            'codec': 'SF',
            'cod': 'cSF',
            'denumire': 'SF',
            'tab': 'venituri',
            'set': 'cSet3'
          },
          {
            '_id': 'sd',
            'codec': 'SD',
            'cod': 'cSD',
            'denumire': 'SD',
            'tab': 'venituri',
            'set': 'cSet3'
          },
          {
            '_id': 'op',
            'codec': 'Op',
            'cod': 'cOp',
            'denumire': 'Op',
            'tab': 'venituri',
            'set': 'cSet4'
          },
          {
            '_id': 'fin',
            'codec': 'Fin',
            'cod': 'cFin',
            'denumire': 'Fin',
            'tab': 'venituri',
            'set': 'cSet4'
          },
          {
            '_id': 'inv',
            'codec': 'Inv',
            'cod': 'cInv',
            'denumire': 'Inv',
            'tab': 'venituri',
            'set': 'cSet4'
          }
        ].concat(venituri.map(v => {
          return {
            ...v,
            'set': 'cSet1',
            disabled: false
          }
        }))

        const chfctResponse = await fetch(`${this.host}/clasificatie?$paginate=false&perioada=${this.selectedPerioadaId}&tab=chfct&$select=denumire&$select=codec&$select=cod&$select=tab&$sort[index]=1`, {
          method: 'get',
          headers
        })
        const chfct = await chfctResponse.json()
        this.clasificatieChfct = [
          {
            '_id': 'achf',
            'codec': 'AChF',
            'cod': 'cAChF',
            'denumire': 'Alte cheltuieli functionale',
            'tab': 'chfct',
            'set': 'cSet2'
          }
        ].concat(chfct.map(v => {
          return {
            ...v,
            'set': 'cSet1',
            disabled: false
          }
        }))

        const checResponse = await fetch(`${this.host}/clasificatie?$paginate=false&perioada=${this.selectedPerioadaId}&tab=chec&$select=denumire&$select=codec&$select=cod&$select=tab&$sort[index]=1`, {
          method: 'get',
          headers
        })
        const chec = await checResponse.json()
        this.clasificatieChec = [
          {
            '_id': 'ache',
            'codec': 'AChE',
            'cod': 'cAChE',
            'denumire': 'Alte cheltuieli economice',
            'tab': 'chec',
            'set': 'cSet4'
          },
          {
            '_id': 'sf',
            'codec': 'SF',
            'cod': 'cSF',
            'denumire': 'SF',
            'tab': 'chec',
            'set': 'cSet2'
          },
          {
            '_id': 'sd',
            'codec': 'SD',
            'cod': 'cSD',
            'denumire': 'SD',
            'tab': 'chec',
            'set': 'cSet2'
          },
          {
            '_id': 'op',
            'codec': 'Op',
            'cod': 'cOp',
            'denumire': 'Op',
            'tab': 'chec',
            'set': 'cSet3'
          },
          {
            '_id': 'fin',
            'codec': 'Fin',
            'cod': 'cFin',
            'denumire': 'Fin',
            'tab': 'chec',
            'set': 'cSet3'
          },
          {
            '_id': 'inv',
            'codec': 'Inv',
            'cod': 'cInv',
            'denumire': 'Inv',
            'tab': 'chec',
            'set': 'cSet3'
          }
        ].concat(chec.map(v => {
          return {
            ...v,
            disabled: false,
            'set': 'cSet1'
          }
        }))

        const ecParentResponse = await fetch(`${this.host}/clasificatie?$paginate=false&perioada=${this.selectedPerioadaId}&tab=chfct&$select=denumire&$select=codec&$select=cod&$select=tab&$sort[index]=1&ecParent=true`, {
          method: 'get',
          headers
        })
        const ecParent = await ecParentResponse.json()
        this.ecParents = [ {
          _id: 'total',
          cod: 'c0000',
          codec: 'Total',
          denumire: 'Total',
          tab: 'chfct'
        }, ...ecParent ]
      } catch (err) {
        console.log(err)
      }
    },
    async getIndicatori () {
      // tab[$in]=chstdla&tab[$in]=venstdla&tab[$in]=inteprexela&tab[$in]=stdeprexela&
      // chstdla venstdla inteprexela stdeprexela

      // /indicatori?$paginate=false&$select=denumire&$select=cod&$select=tab&tab=chstdla&$sort[denumire]=1
      // /indicatori?$paginate=false&$select=denumire&$select=cod&$select=tab&tab=venstdla&$sort[denumire]=1
      // /indicatori?$paginate=false&$select=denumire&$select=cod&$select=tab&tab=inteprexela&$sort[denumire]=1
      // /indicatori?$paginate=false&$select=denumire&$select=cod&$select=tab&tab=stdeprexela&$sort[denumire]=1

      const headers = new Headers({
        'Content-Type': 'application/json',
        'Authorization': this.token
      })

      try {
        const chstdResponse = await fetch(`${this.host}/indicatori?$paginate=false&perioada=${this.selectedPerioadaId}&$select=denumire&$select=cod&$select=tab&tab=chstdla&formula[$ne]=&$sort[denumire]=1`, {
          method: 'get',
          headers
        })
        const chstd = await chstdResponse.json()
        this.indicatoriCheltuieli = chstd.map(v => {
          return {
            ...v,
            disabled: false
          }
        })

        const venstdResponse = await fetch(`${this.host}/indicatori?$paginate=false&perioada=${this.selectedPerioadaId}&$select=denumire&$select=cod&$select=tab&tab=venstdla&formula[$ne]=&$sort[denumire]=1`, {
          method: 'get',
          headers
        })
        const venstd = await venstdResponse.json()
        this.indicatoriVenituri = venstd.map(v => {
          return {
            ...v,
            disabled: false
          }
        })

        const inteprResponse = await fetch(`${this.host}/indicatori?$paginate=false&perioada=${this.selectedPerioadaId}&$select=denumire&$select=cod&$select=tab&tab=inteprexela&formula[$ne]=&$sort[denumire]=1`, {
          method: 'get',
          headers
        })
        const intepr = await inteprResponse.json()
        this.indicatoriIntepr = intepr.map(v => {
          return {
            ...v,
            disabled: false
          }
        })

        const stdeprResponse = await fetch(`${this.host}/indicatori?$paginate=false&perioada=${this.selectedPerioadaId}&$select=denumire&$select=cod&$select=tab&tab=stdeprexela&formula[$ne]=&$sort[denumire]=1`, {
          method: 'get',
          headers
        })
        const stdepr = await stdeprResponse.json()
        this.indicatoriStdepr = stdepr.map(v => {
          return {
            ...v,
            disabled: false
          }
        })
      } catch (err) {
        console.log(err)
      }
    },

    async finishDatasetCustomization () {
      const dataRows = this.formattedCifuri.map(cif => {
        const cells = []

        this.formattedProps.forEach(prop => {
          cells.push(`${prop}_${cif}`)
        })

        this.formattedClasificatieVenituri.forEach(item => {
          cells.push(`${item}_${cif}`)
        })
        this.formattedClasificatieChfct.forEach(item => {
          cells.push(`${item}_${cif}`)
        })
        this.formattedClasificatieChec.forEach(item => {
          cells.push(`${item}_${cif}`)
        })

        this.formattedIndicatoriVenituri.forEach(item => {
          cells.push(`${item}_${cif}`)
        })
        this.formattedIndicatoriCheltuieli.forEach(item => {
          cells.push(`${item}_${cif}`)
        })
        this.formattedIndicatoriIntepr.forEach(item => {
          cells.push(`${item}_${cif}`)
        })
        this.formattedIndicatoriStdepr.forEach(item => {
          cells.push(`${item}_${cif}`)
        })

        return cells
      })

      const labelRows = dataRows[0].map(item => `${item}-label`)

      this.hotSettings.colHeaders = []
      this.hotData = []

      await this.getLabels(labelRows)
      await this.getData(dataRows)
    },
    async getLabels (items) {
      this.loadingLabels = true
      this.labelsRow = []
      const rowResponse = await fetch(`${this.host}/interactive-reports-values`, {
        method: 'post',
        headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': this.token
        }),
        body: JSON.stringify({ items, lang: this.lang })
      })
      const row = await rowResponse.json()

      this.labelsRow = ['Nr. crt.'].concat(row)
      this.loadingLabels = false

      this.hotSettings.colHeaders = [ ...this.labelsRow ]
    },
    async getData (items) {
      this.loadingData = true
      this.dataRows = []
      let index = 1
      for (let item of items) {
        const rowResponse = await fetch(`${this.host}/interactive-reports-values`, {
          method: 'post',
          headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': this.token
          }),
          body: JSON.stringify({ items: item, lang: this.lang })
        })
        const row = await rowResponse.json()
        this.dataRows.push([index].concat(row))

        this.hotData.push([index].concat(row))
        index++
      }
      this.loadingData = false
    },

    exceller () {
      let table = `<thead><tr><th colspan="${this.labelsRow.length}">${this.reportName}<th></tr><tr><th></th></tr><tr>`

      this.labelsRow.forEach(label => {
        table += `<th>${label}</th>`
      })
      table += '</tr></thead>'

      table += '<tbody>'
      this.dataRows.forEach((row, index) => {
        table += '<tr>'
        row.forEach(cell => {
          table += `<td>${cell}</td>`
        })
        table += '</tr>'
      })
      table += '</tbody>'

      let uri = 'data:application/vnd.ms-excel;base64,'
      let template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table><tr><td>{table}</td></tr></table></body></html>'
      const base64 = function (s) {
        return window.btoa(unescape(encodeURIComponent(s)))
      }
      const format = function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p]
        })
      }
      // let toExcel = document.querySelector('.data-table table').innerHTML
      let ctx = {
        worksheet: `TUDs Analytics Raport Interactiv ${(new Date()).toLocaleString('ro-RO').replace(/,/g, ' ').replace(/:/g, '.')}`,
        table
      }
      let link = document.createElement('a')
      link.download = `TUDs Analytics Raport Interactiv ${(new Date()).toLocaleString('ro-RO').replace(/,/g, ' ').replace(/:/g, '.')}.xls`
      link.href = uri + base64(format(template, ctx))
      link.click()
    },
    dummy () {}
  },
  async created () {
    await this.getCifuri()
    await this.getClasificatie()
    await this.getIndicatori()
  }
}
</script>

<style>
  .template-strings-table thead th {
    border-bottom: thin solid #ccc;
  }

  .template-strings-table th, .template-strings-table td {
    padding: 6px;
    vertical-align: middle;
    border-bottom: thin solid #ccc;
  }

  /*!
  * Copyright (c) HANDSONCODE sp. z o. o.
  *
  * HANDSONTABLE is a software distributed by HANDSONCODE sp. z o. o.,
  * a Polish corporation, based in Gdynia, Poland, at 96/98 Aleja Zwycięstwa,
  * registered with the National Court Register under number 538651,
  * EU tax ID number: PL5862294002, share capital: PLN 62,800.00.
  *
  * This software is protected by applicable copyright laws, including
  * international treaties, and dual-licensed – depending on whether
  * your use is intended for or may result in commercial advantage
  * or monetary compensation (commercial purposes), or not.
  *
  * If your use involves only such purposes as research, private study,
  * evaluation and the like, you agree to be bound by the terms included
  * in the "handsontable-non-commercial-license.pdf" file, available
  * in the main directory of this software repository.
  *
  * By installing, copying, or otherwise using this software for
  * commercial purposes, you agree to be bound by the terms included
  * in the "handsontable-general-terms.pdf" file, available in the main
  * directory of this software repository.
  *
  * HANDSONCODE PROVIDES THIS SOFTWARE ON AN "AS IS" BASIS,
  * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND. IN NO EVENT
  * AND UNDER NO LEGAL THEORY, SHALL HANDSONCODE BE LIABLE
  * TO YOU FOR DAMAGES, INCLUDING ANY DIRECT, INDIRECT, SPECIAL,
  * INCIDENTAL, OR CONSEQUENTIAL DAMAGES OF ANY CHARACTER ARISING
  * FROM USE OR INABILITY TO USE THIS SOFTWARE.
  *
  * Version: 7.4.2
  * Release date: 19/02/2020 (built at 19/02/2020 13:44:06)
  */
  /**
  * Fix for bootstrap styles
  */
  .handsontable .table th, .handsontable .table td {
    border-top: none;
  }

  .handsontable tr {
    background: #fff;
  }

  .handsontable td {
    background-color: inherit;
  }

  .handsontable .table caption + thead tr:first-child th,
  .handsontable .table caption + thead tr:first-child td,
  .handsontable .table colgroup + thead tr:first-child th,
  .handsontable .table colgroup + thead tr:first-child td,
  .handsontable .table thead:first-child tr:first-child th,
  .handsontable .table thead:first-child tr:first-child td {
    border-top: 1px solid #CCCCCC;
  }

  /* table-bordered */
  .handsontable .table-bordered {
    border: 0;
    border-collapse: separate;
  }

  .handsontable .table-bordered th,
  .handsontable .table-bordered td {
    border-left: none;
  }

  .handsontable .table-bordered th:first-child,
  .handsontable .table-bordered td:first-child {
    border-left: 1px solid #CCCCCC;
  }

  .handsontable .table > tbody > tr > td,
  .handsontable .table > tbody > tr > th,
  .handsontable .table > tfoot > tr > td,
  .handsontable .table > tfoot > tr > th,
  .handsontable .table > thead > tr > td,
  .handsontable .table > thead > tr > th {
    line-height: 21px;
    padding: 0 4px;
  }

  .col-lg-1.handsontable, .col-lg-10.handsontable, .col-lg-11.handsontable, .col-lg-12.handsontable,
  .col-lg-2.handsontable, .col-lg-3.handsontable, .col-lg-4.handsontable, .col-lg-5.handsontable, .col-lg-6.handsontable, .col-lg-7.handsontable, .col-lg-8.handsontable, .col-lg-9.handsontable,
  .col-md-1.handsontable, .col-md-10.handsontable, .col-md-11.handsontable, .col-md-12.handsontable,
  .col-md-2.handsontable, .col-md-3.handsontable, .col-md-4.handsontable, .col-md-5.handsontable, .col-md-6.handsontable, .col-md-7.handsontable, .col-md-8.handsontable, .col-md-9.handsontable
  .col-sm-1.handsontable, .col-sm-10.handsontable, .col-sm-11.handsontable, .col-sm-12.handsontable,
  .col-sm-2.handsontable, .col-sm-3.handsontable, .col-sm-4.handsontable, .col-sm-5.handsontable, .col-sm-6.handsontable, .col-sm-7.handsontable, .col-sm-8.handsontable, .col-sm-9.handsontable
  .col-xs-1.handsontable, .col-xs-10.handsontable, .col-xs-11.handsontable, .col-xs-12.handsontable,
  .col-xs-2.handsontable, .col-xs-3.handsontable, .col-xs-4.handsontable, .col-xs-5.handsontable, .col-xs-6.handsontable, .col-xs-7.handsontable, .col-xs-8.handsontable, .col-xs-9.handsontable {
    padding-left: 0;
    padding-right: 0;
  }

  .handsontable .table-striped > tbody > tr:nth-of-type(even) {
    background-color: #FFF;
  }

  .handsontable {
    position: relative;
  }

  .handsontable .hide {
    display: none;
  }

  .handsontable .relative {
    position: relative;
  }

  .handsontable.htAutoSize {
    visibility: hidden;
    left: -99000px;
    position: absolute;
    top: -99000px;
  }

  .handsontable .wtHider {
    width: 0;
  }

  .handsontable .wtSpreader {
    position: relative;
    width: 0; /*must be 0, otherwise blank space appears in scroll demo after scrolling max to the right */
    height: auto;
  }

  .handsontable table,
  .handsontable tbody,
  .handsontable thead,
  .handsontable td,
  .handsontable th,
  .handsontable input,
  .handsontable textarea,
  .handsontable div {
    box-sizing: content-box;
    -webkit-box-sizing: content-box;
    -moz-box-sizing: content-box;
  }

  .handsontable input,
  .handsontable textarea {
    min-height: initial;
  }

  .handsontable table.htCore {
    border-collapse: separate;
    /* it must be separate, otherwise there are offset miscalculations in WebKit: http://stackoverflow.com/questions/2655987/border-collapse-differences-in-ff-and-webkit */
    /* this actually only changes appearance of user selection - does not make text unselectable */
    /* -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -o-user-select: none;
    -ms-user-select: none;
    user-select: none; */ /* no browser supports unprefixed version */
    border-spacing: 0;
    margin: 0;
    border-width: 0;
    table-layout: fixed;
    width: 0;
    outline-width: 0;
    cursor: default;
    /* reset bootstrap table style. for more info see: https://github.com/handsontable/handsontable/issues/224 */
    max-width: none;
    max-height: none;
  }

  .handsontable col {
    width: 50px;
  }

  .handsontable col.rowHeader {
    width: 50px;
  }

  .handsontable th,
  .handsontable td {
    border-top-width: 0;
    border-left-width: 0;
    border-right: 1px solid #CCC;
    border-bottom: 1px solid #CCC;
    height: 22px;
    empty-cells: show;
    line-height: 21px;
    padding: 0 4px 0 4px;
    /* top, bottom padding different than 0 is handled poorly by FF with HTML5 doctype */
    background-color: #FFF;
    vertical-align: top;
    overflow: hidden;
    outline-width: 0;
    white-space: pre-line;
    /* preserve new line character in cell */
  }

  .handsontable td.htInvalid {
    background-color: #ff4c42 !important; /*gives priority over td.area selection background*/
  }

  .handsontable td.htNoWrap {
    white-space: nowrap;
  }

  .handsontable th:last-child {
    /*Foundation framework fix*/
    border-right: 1px solid #CCC;
    border-bottom: 1px solid #CCC;
  }

  .handsontable tr:first-child th.htNoFrame,
  .handsontable th:first-child.htNoFrame,
  .handsontable th.htNoFrame {
    border-left-width: 0;
    background-color: white;
    border-color: #FFF;
  }

  .handsontable th:first-child,
  .handsontable th:nth-child(2),
  .handsontable td:first-of-type,
  .handsontable .htNoFrame + th,
  .handsontable .htNoFrame + td {
    border-left: 1px solid #CCC;
  }

  .handsontable.htRowHeaders thead tr th:nth-child(2) {
    border-left: 1px solid #CCC;
  }

  .handsontable tr:first-child th,
  .handsontable tr:first-child td {
    border-top: 1px solid #CCC;
  }

  .ht_master:not(.innerBorderLeft):not(.emptyColumns) ~ .handsontable tbody tr th,
  .ht_master:not(.innerBorderLeft):not(.emptyColumns) ~ .handsontable:not(.ht_clone_top) thead tr th:first-child {
    border-right-width: 0;
  }

  .ht_master:not(.innerBorderTop) thead tr:last-child th,
  .ht_master:not(.innerBorderTop) ~ .handsontable thead tr:last-child th,
  .ht_master:not(.innerBorderTop) thead tr.lastChild th,
  .ht_master:not(.innerBorderTop) ~ .handsontable thead tr.lastChild th {
    border-bottom-width: 0;
  }

  .handsontable th {
    background-color: #f0f0f0;
    color: #222;
    text-align: center;
    font-weight: normal;
    white-space: nowrap;
  }

  .handsontable thead th {
    padding: 0;
  }

  .handsontable th.active {
    background-color: #CCC;
  }
  .handsontable thead th .relative {
    padding: 2px 4px;
  }

  #hot-display-license-info {
    font-size: 10px;
    color: #323232 ;
    padding: 5px 0 3px 0;
    font-family: Helvetica, Arial, sans-serif;
    text-align: left;
  }

  #hot-display-license-info a {
    font-size: 10px;
  }

  /* plugins */

  /* row + column resizer*/
  .handsontable .manualColumnResizer {
    position: absolute;
    top: 0;
    cursor: col-resize;
    z-index: 210;
    width: 5px;
    height: 25px;
  }

  .handsontable .manualRowResizer {
    position: absolute;
    left: 0;
    cursor: row-resize;
    z-index: 210;
    height: 5px;
    width: 50px;
  }

  .handsontable .manualColumnResizer:hover,
  .handsontable .manualColumnResizer.active,
  .handsontable .manualRowResizer:hover,
  .handsontable .manualRowResizer.active {
    background-color: #34a9db;
  }

  .handsontable .manualColumnResizerGuide {
    position: absolute;
    right: 0;
    top: 0;
    background-color: #34a9db;
    display: none;
    width: 0;
    border-right: 1px dashed #777;
    margin-left: 5px;
  }

  .handsontable .manualRowResizerGuide {
    position: absolute;
    left: 0;
    bottom: 0;
    background-color: #34a9db;
    display: none;
    height: 0;
    border-bottom: 1px dashed #777;
    margin-top: 5px;
  }

  .handsontable .manualColumnResizerGuide.active,
  .handsontable .manualRowResizerGuide.active {
    display: block;
    z-index: 209;
  }

  .handsontable .columnSorting {
    position: relative;
  }

  .handsontable .columnSorting.sortAction:hover {
    text-decoration: underline;
    cursor: pointer;
  }

  .handsontable span.colHeader {
    display: inline-block;
    line-height: 1.1;
  }

  /* Arrow position */
  .handsontable span.colHeader.columnSorting::before {
    /* Centering start */
    top: 50%;
    margin-top: -6px; /* One extra pixel for purpose of proper positioning of sorting arrow, when `font-size` set to default */
    /* Centering end */

    padding-left: 8px; /* For purpose of continuous mouse over experience, when moving between the `span` and the `::before` elements */
    position: absolute;
    right: -9px;

    content: '';
    height: 10px;
    width: 5px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position-x: right;
  }

  .handsontable span.colHeader.columnSorting.ascending::before {
    /* arrow up; 20 x 40 px, scaled to 5 x 10 px; base64 size: 0.3kB */
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAoCAMAAADJ7yrpAAAAKlBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKE86IAAAADXRSTlMABBEmRGprlJW72e77tTkTKwAAAFNJREFUeAHtzjkSgCAUBNHPgsoy97+ulGXRqJE5L+xkxoYt2UdsLb5bqFINz+aLuuLn5rIu2RkO3fZpWENimNgiw6iBYRTPMLJjGFxQZ1hxxb/xBI1qC8k39CdKAAAAAElFTkSuQmCC");
  }

  .handsontable span.colHeader.columnSorting.descending::before {
    /* arrow down; 20 x 40 px, scaled to 5 x 10 px; base64 size: 0.3kB */
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAoCAMAAADJ7yrpAAAAKlBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKE86IAAAADXRSTlMABBEmRGprlJW72e77tTkTKwAAAFJJREFUeAHtzjkSgCAQRNFmQYUZ7n9dKUvru0TmvPAn3br0QfgdZ5xx6x+rQn23GqTYnq1FDcnuzZIO2WmedVqIRVxgGKEyjNgYRjKGkZ1hFIZ3I70LyM0VtU8AAAAASUVORK5CYII=");
  }

  .htGhostTable .htCore span.colHeader.columnSorting:not(.indicatorDisabled)::after {
    content: '*';
    display: inline-block;
    position: relative;
    /* The multi-line header and header with longer text need more padding to not hide arrow,
    we make header wider in `GhostTable` to make some space for arrow which is positioned absolutely in the main table */
    padding-right: 20px;
  }

  /* Selection */
  .handsontable .wtBorder {
    position: absolute;
    font-size: 0;
  }
  .handsontable .wtBorder.hidden{
    display:none !important;
  }

  /* A layer order of the selection types */
  .handsontable .wtBorder.current {
    z-index: 10;
  }
  .handsontable .wtBorder.area {
    z-index: 8;
  }
  .handsontable .wtBorder.fill {
    z-index: 6;
  }

  .handsontable td.area,
  .handsontable td.area-1,
  .handsontable td.area-2,
  .handsontable td.area-3,
  .handsontable td.area-4,
  .handsontable td.area-5,
  .handsontable td.area-6,
  .handsontable td.area-7 {
    position: relative;
  }

  .handsontable td.area:before,
  .handsontable td.area-1:before,
  .handsontable td.area-2:before,
  .handsontable td.area-3:before,
  .handsontable td.area-4:before,
  .handsontable td.area-5:before,
  .handsontable td.area-6:before,
  .handsontable td.area-7:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    bottom: -100%\9; /* Fix for IE9 to spread the ":before" pseudo element to 100% height of the parent element */
    background: #005eff;
  }

  /* Fix for IE10 and IE11 to spread the ":before" pseudo element to 100% height of the parent element */
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .handsontable td.area:before,
    .handsontable td.area-1:before,
    .handsontable td.area-2:before,
    .handsontable td.area-3:before,
    .handsontable td.area-4:before,
    .handsontable td.area-5:before,
    .handsontable td.area-6:before,
    .handsontable td.area-7:before {
      bottom: -100%;
    }
  }

  .handsontable td.area:before {
    opacity: 0.1;
  }
  .handsontable td.area-1:before {
    opacity: 0.2;
  }
  .handsontable td.area-2:before {
    opacity: 0.27;
  }
  .handsontable td.area-3:before {
    opacity: 0.35;
  }
  .handsontable td.area-4:before {
    opacity: 0.41;
  }
  .handsontable td.area-5:before {
    opacity: 0.47;
  }
  .handsontable td.area-6:before {
    opacity: 0.54;
  }
  .handsontable td.area-7:before {
    opacity: 0.58;
  }

  .handsontable tbody th.ht__highlight,
  .handsontable thead th.ht__highlight {
    background-color: #dcdcdc;
  }

  .handsontable tbody th.ht__active_highlight,
  .handsontable thead th.ht__active_highlight {
    background-color: #8eb0e7;
    color: #000;
  }

  /* fill handle */

  .handsontable .wtBorder.corner {
    font-size: 0;
    cursor: crosshair;
  }

  .handsontable .htBorder.htFillBorder {
    background: red;
    width: 1px;
    height: 1px;
  }

  .handsontableInput {
    border: none;
    outline-width: 0;
    margin: 0;
    padding: 1px 5px 0 5px;
    font-family: inherit;
    line-height: 21px;
    font-size: inherit;
    box-shadow: 0 0 0 2px #5292F7 inset;
    resize: none;
    /*below are needed to overwrite stuff added by jQuery UI Bootstrap theme*/
    display: block;
    color: #000;
    border-radius: 0;
    background-color: #FFF;
    /*overwrite styles potentionally made by a framework*/
  }

  .handsontableInputHolder {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 104;
  }

  .htSelectEditor {
    -webkit-appearance: menulist-button !important;
    position: absolute;
    width: auto;
  }

  /*
  TextRenderer readOnly cell
  */

  .handsontable .htDimmed {
    color: #777;
  }

  .handsontable .htSubmenu {
    position: relative;
  }

  .handsontable .htSubmenu :after{
    content: '\25B6';
    color: #777;
    position: absolute;
    right: 5px;
    font-size: 9px;
  }

  /*
  TextRenderer horizontal alignment
  */
  .handsontable .htLeft{
    text-align: left;
  }
  .handsontable .htCenter{
    text-align: center;
  }
  .handsontable .htRight{
    text-align: right;
  }
  .handsontable .htJustify{
    text-align: justify;
  }
  /*
  TextRenderer vertical alignment
  */
  .handsontable .htTop{
    vertical-align: top;
  }
  .handsontable .htMiddle{
    vertical-align: middle;
  }
  .handsontable .htBottom{
    vertical-align: bottom;
  }

  /*
  TextRenderer placeholder value
  */

  .handsontable .htPlaceholder {
    color: #999;
  }

  /*
  AutocompleteRenderer down arrow
  */

  .handsontable .htAutocompleteArrow {
    float: right;
    font-size: 10px;
    color: #EEE;
    cursor: default;
    width: 16px;
    text-align: center;
  }

  .handsontable td .htAutocompleteArrow:hover {
    color: #777;
  }

  .handsontable td.area .htAutocompleteArrow {
    color: #d3d3d3;
  }

  /*
  CheckboxRenderer
  */
  .handsontable .htCheckboxRendererInput {
    display: inline-block;
  }
  .handsontable .htCheckboxRendererInput.noValue {
    opacity: 0.5;
  }
  .handsontable .htCheckboxRendererLabel {
    font-size: inherit;
    vertical-align: middle;
    cursor: pointer;
    display: inline-block;
    width: 100%;
  }

  /**
  * Handsontable in Handsontable
  */

  .handsontable .handsontable.ht_clone_top .wtHider {
    padding: 0 0 5px 0;
  }

  /**
  * Autocomplete Editor
  */
  .handsontable .autocompleteEditor.handsontable {
    padding-right: 17px;
  }
  .handsontable .autocompleteEditor.handsontable.htMacScroll {
    padding-right: 15px;
  }

  /**
  * Handsontable listbox theme
  */

  .handsontable.listbox {
    margin: 0;
  }

  .handsontable.listbox .ht_master table {
    border: 1px solid #ccc;
    border-collapse: separate;
    background: white;
  }

  .handsontable.listbox th,
  .handsontable.listbox tr:first-child th,
  .handsontable.listbox tr:last-child th,
  .handsontable.listbox tr:first-child td,
  .handsontable.listbox td {
    border-color: transparent;
  }

  .handsontable.listbox th,
  .handsontable.listbox td {
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .handsontable.listbox td.htDimmed {
    cursor: default;
    color: inherit;
    font-style: inherit;
  }

  .handsontable.listbox .wtBorder {
    visibility: hidden;
  }

  .handsontable.listbox tr td.current,
  .handsontable.listbox tr:hover td {
    background: #eee;
  }

  .ht_editor_hidden {
    z-index: -1;
  }

  .ht_editor_visible {
    z-index: 200;
  }

  .ht_clone_master {
    z-index: 100;
  }

  .ht_clone_right {
    z-index: 110;
  }

  .ht_clone_left {
    z-index: 120;
  }

  .ht_clone_bottom {
    z-index: 130;
  }

  .ht_clone_bottom_right_corner {
    z-index: 140;
  }

  .ht_clone_bottom_left_corner {
    z-index: 150;
  }

  .ht_clone_top {
    z-index: 160;
  }

  .ht_clone_top_right_corner {
    z-index: 170;
  }

  .ht_clone_top_left_corner {
    z-index: 180;
  }

  .handsontable td.htSearchResult {
    background: #fcedd9;
    color: #583707;
  }

  /*
  Cell borders
  */
  .htBordered{
    /*box-sizing: border-box !important;*/
    border-width: 1px;
  }
  .htBordered.htTopBorderSolid {
    border-top-style: solid;
    border-top-color: #000;
  }
  .htBordered.htRightBorderSolid {
    border-right-style: solid;
    border-right-color: #000;
  }
  .htBordered.htBottomBorderSolid {
    border-bottom-style: solid;
    border-bottom-color: #000;
  }
  .htBordered.htLeftBorderSolid {
    border-left-style: solid;
    border-left-color: #000;
  }

  .handsontable tbody tr th:nth-last-child(2) {
    border-right: 1px solid #CCC;
  }

  .handsontable thead tr:nth-last-child(2) th.htGroupIndicatorContainer {
    border-bottom: 1px solid #CCC;
    padding-bottom: 5px;
  }

  .ht_clone_top_left_corner thead tr th:nth-last-child(2) {
    border-right: 1px solid #CCC;
  }

  .htCollapseButton {
    width: 10px;
    height: 10px;
    line-height: 10px;
    text-align: center;
    border-radius: 5px;
    border: 1px solid #f3f3f3;
    -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.4);
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.4);
    cursor: pointer;
    margin-bottom: 3px;
    position: relative;
  }

  .htCollapseButton:after {
    content: "";
    height: 300%;
    width: 1px;
    display: block;
    background: #ccc;
    margin-left: 4px;
    position: absolute;
    /*top: -300%;*/
    bottom: 10px;
  }

  thead .htCollapseButton {
    right: 5px;
    position: absolute;
    top: 5px;
    background: #fff;
  }

  thead .htCollapseButton:after {
    height: 1px;
    width: 700%;
    right: 10px;
    top: 4px;
  }

  .handsontable tr th .htExpandButton {
    position: absolute;
    width: 10px;
    height: 10px;
    line-height: 10px;
    text-align: center;
    border-radius: 5px;
    border: 1px solid #f3f3f3;
    -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.4);
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.4);
    cursor: pointer;
    top: 0;
    display: none;
  }

  .handsontable thead tr th .htExpandButton {
    /*left: 5px;*/
    top: 5px;
  }

  .handsontable tr th .htExpandButton.clickable {
    display: block;
  }

  .collapsibleIndicator {
    position: absolute;
    top: 50%;
    transform: translate(0% ,-50%);
    right: 5px;
    border: 1px solid #A6A6A6;
    line-height: 10px;
    color: #222;
    border-radius: 10px;
    font-size: 10px;
    width: 10px;
    height: 10px;
    cursor: pointer;
    -webkit-box-shadow: 0 0 0 6px rgba(238,238,238,1);
    -moz-box-shadow: 0 0 0 6px rgba(238,238,238,1);
    box-shadow: 0 0 0 6px rgba(238,238,238,1);
    background: #eee;
  }

  .handsontable col.hidden {
    width: 0 !important;
  }

  .handsontable table tr th.lightRightBorder {
    border-right: 1px solid #E6E6E6;
  }

  .handsontable tr.hidden,
  .handsontable tr.hidden td,
  .handsontable tr.hidden th {
    display: none;
  }

  .ht_master,
  .ht_clone_left,
  .ht_clone_top,
  .ht_clone_bottom {
    overflow: hidden;
  }

  .ht_master .wtHolder {
    overflow: auto;
  }

  .handsontable .ht_master thead,
  .handsontable .ht_master tr th,
  .handsontable .ht_clone_left thead {
    visibility: hidden;
  }

  .ht_clone_top .wtHolder,
  .ht_clone_left .wtHolder,
  .ht_clone_bottom .wtHolder {
    overflow: hidden;
  }

  /*

  Handsontable Mobile Text Editor stylesheet

  */

  .handsontable.mobile,
  .handsontable.mobile .wtHolder {
    -webkit-touch-callout:none;
    -webkit-user-select:none;
    -khtml-user-select:none;
    -moz-user-select:none;
    -ms-user-select:none;
    user-select:none;
    -webkit-tap-highlight-color:rgba(0,0,0,0);
    -webkit-overflow-scrolling: touch;
  }

  .htMobileEditorContainer {
    display: none;
    position: absolute;
    top: 0;
    width: 70%;
    height: 54pt;
    background: #f8f8f8;
    border-radius: 20px;
    border: 1px solid #ebebeb;
    z-index: 999;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -webkit-text-size-adjust: none;
  }

  .topLeftSelectionHandle:not(.ht_master .topLeftSelectionHandle),
  .topLeftSelectionHandle-HitArea:not(.ht_master .topLeftSelectionHandle-HitArea) {
    z-index: 9999;
  }

  /* Initial left/top coordinates - overwritten when actual position is set */
  .topLeftSelectionHandle,
  .topLeftSelectionHandle-HitArea,
  .bottomRightSelectionHandle,
  .bottomRightSelectionHandle-HitArea {
    left: -10000px;
    top: -10000px;
  }

  .htMobileEditorContainer.active {
    display: block;
  }

  .htMobileEditorContainer .inputs {
    position: absolute;
    right: 210pt;
    bottom: 10pt;
    top: 10pt;
    left: 14px;
    height: 34pt;
  }

  .htMobileEditorContainer .inputs textarea {
    font-size: 13pt;
    border: 1px solid #a1a1a1;
    -webkit-appearance: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    position: absolute;
    left: 14px;
    right: 14px;
    top: 0;
    bottom: 0;
    padding: 7pt;
  }

  .htMobileEditorContainer .cellPointer {
    position: absolute;
    top: -13pt;
    height: 0;
    width: 0;
    left: 30px;

    border-left: 13pt solid transparent;
    border-right: 13pt solid transparent;
    border-bottom: 13pt solid #ebebeb;
  }

  .htMobileEditorContainer .cellPointer.hidden {
    display: none;
  }

  .htMobileEditorContainer .cellPointer:before {
    content: '';
    display: block;
    position: absolute;
    top: 2px;
    height: 0;
    width: 0;
    left: -13pt;

    border-left: 13pt solid transparent;
    border-right: 13pt solid transparent;
    border-bottom: 13pt solid #f8f8f8;
  }

  .htMobileEditorContainer .moveHandle {
    position: absolute;
    top: 10pt;
    left: 5px;
    width: 30px;
    bottom: 0px;
    cursor: move;
    z-index: 9999;
  }

  .htMobileEditorContainer .moveHandle:after {
    content: "..\a..\a..\a..";
    white-space: pre;
    line-height: 10px;
    font-size: 20pt;
    display: inline-block;
    margin-top: -8px;
    color: #ebebeb;
  }

  .htMobileEditorContainer .positionControls {
    width: 205pt;
    position: absolute;
    right: 5pt;
    top: 0;
    bottom: 0;
  }

  .htMobileEditorContainer .positionControls > div {
    width: 50pt;
    height: 100%;
    float: left;
  }

  .htMobileEditorContainer .positionControls > div:after {
    content: " ";
    display: block;
    width: 15pt;
    height: 15pt;
    text-align: center;
    line-height: 50pt;
  }

  .htMobileEditorContainer .leftButton:after,
  .htMobileEditorContainer .rightButton:after,
  .htMobileEditorContainer .upButton:after,
  .htMobileEditorContainer .downButton:after {
    transform-origin: 5pt 5pt;
    -webkit-transform-origin: 5pt 5pt;
    margin: 21pt 0 0 21pt;
  }

  .htMobileEditorContainer .leftButton:after {
    border-top: 2px solid #288ffe;
    border-left: 2px solid #288ffe;
    -webkit-transform: rotate(-45deg);
    /*margin-top: 17pt;*/
    /*margin-left: 20pt;*/
  }
  .htMobileEditorContainer .leftButton:active:after {
    border-color: #cfcfcf;
  }

  .htMobileEditorContainer .rightButton:after {
    border-top: 2px solid #288ffe;
    border-left: 2px solid #288ffe;
    -webkit-transform: rotate(135deg);
    /*margin-top: 17pt;*/
    /*margin-left: 10pt;*/
  }
  .htMobileEditorContainer .rightButton:active:after {
    border-color: #cfcfcf;
  }

  .htMobileEditorContainer .upButton:after {
    /*border-top: 2px solid #cfcfcf;*/
    border-top: 2px solid #288ffe;
    border-left: 2px solid #288ffe;
    -webkit-transform: rotate(45deg);
    /*margin-top: 22pt;*/
    /*margin-left: 15pt;*/
  }
  .htMobileEditorContainer .upButton:active:after {
    border-color: #cfcfcf;
  }

  .htMobileEditorContainer .downButton:after {
    border-top: 2px solid #288ffe;
    border-left: 2px solid #288ffe;
    -webkit-transform: rotate(225deg);
    /*margin-top: 15pt;*/
    /*margin-left: 15pt;*/
  }
  .htMobileEditorContainer .downButton:active:after {
    border-color: #cfcfcf;
  }

  .handsontable.hide-tween {
    -webkit-animation: opacity-hide 0.3s;
    animation: opacity-hide 0.3s;
    animation-fill-mode: forwards;
    -webkit-animation-fill-mode: forwards;
  }

  .handsontable.show-tween {
    -webkit-animation: opacity-show 0.3s;
    animation: opacity-show 0.3s;
    animation-fill-mode: forwards;
    -webkit-animation-fill-mode: forwards;
  }

  @charset "UTF-8";

  /*!
  * Pikaday
  * Copyright © 2014 David Bushell | BSD & MIT license | https://dbushell.com/
  */

  .pika-single {
      z-index: 9999;
      display: block;
      position: relative;
      color: #333;
      background: #fff;
      border: 1px solid #ccc;
      border-bottom-color: #bbb;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  }

  /*
  clear child float (pika-lendar), using the famous micro clearfix hack
  http://nicolasgallagher.com/micro-clearfix-hack/
  */
  .pika-single:before,
  .pika-single:after {
      content: " ";
      display: table;
  }
  .pika-single:after { clear: both }
  .pika-single { *zoom: 1 }

  .pika-single.is-hidden {
      display: none;
  }

  .pika-single.is-bound {
      position: absolute;
      box-shadow: 0 5px 15px -5px rgba(0,0,0,.5);
  }

  .pika-lendar {
      float: left;
      width: 240px;
      margin: 8px;
  }

  .pika-title {
      position: relative;
      text-align: center;
  }

  .pika-label {
      display: inline-block;
      *display: inline;
      position: relative;
      z-index: 9999;
      overflow: hidden;
      margin: 0;
      padding: 5px 3px;
      font-size: 14px;
      line-height: 20px;
      font-weight: bold;
      background-color: #fff;
  }
  .pika-title select {
      cursor: pointer;
      position: absolute;
      z-index: 9998;
      margin: 0;
      left: 0;
      top: 5px;
      filter: alpha(opacity=0);
      opacity: 0;
  }

  .pika-prev,
  .pika-next {
      display: block;
      cursor: pointer;
      position: relative;
      outline: none;
      border: 0;
      padding: 0;
      width: 20px;
      height: 30px;
      /* hide text using text-indent trick, using width value (it's enough) */
      text-indent: 20px;
      white-space: nowrap;
      overflow: hidden;
      background-color: transparent;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: 75% 75%;
      opacity: .5;
      *position: absolute;
      *top: 0;
  }

  .pika-prev:hover,
  .pika-next:hover {
      opacity: 1;
  }

  .pika-prev,
  .is-rtl .pika-next {
      float: left;
      background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAeCAYAAAAsEj5rAAAAUklEQVR42u3VMQoAIBADQf8Pgj+OD9hG2CtONJB2ymQkKe0HbwAP0xucDiQWARITIDEBEnMgMQ8S8+AqBIl6kKgHiXqQqAeJepBo/z38J/U0uAHlaBkBl9I4GwAAAABJRU5ErkJggg==');
      *left: 0;
  }

  .pika-next,
  .is-rtl .pika-prev {
      float: right;
      background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAeCAYAAAAsEj5rAAAAU0lEQVR42u3VOwoAMAgE0dwfAnNjU26bYkBCFGwfiL9VVWoO+BJ4Gf3gtsEKKoFBNTCoCAYVwaAiGNQGMUHMkjGbgjk2mIONuXo0nC8XnCf1JXgArVIZAQh5TKYAAAAASUVORK5CYII=');
      *right: 0;
  }

  .pika-prev.is-disabled,
  .pika-next.is-disabled {
      cursor: default;
      opacity: .2;
  }

  .pika-select {
      display: inline-block;
      *display: inline;
  }

  .pika-table {
      width: 100%;
      border-collapse: collapse;
      border-spacing: 0;
      border: 0;
  }

  .pika-table th,
  .pika-table td {
      width: 14.285714285714286%;
      padding: 0;
  }

  .pika-table th {
      color: #999;
      font-size: 12px;
      line-height: 25px;
      font-weight: bold;
      text-align: center;
  }

  .pika-button {
      cursor: pointer;
      display: block;
      box-sizing: border-box;
      -moz-box-sizing: border-box;
      outline: none;
      border: 0;
      margin: 0;
      width: 100%;
      padding: 5px;
      color: #666;
      font-size: 12px;
      line-height: 15px;
      text-align: right;
      background: #f5f5f5;
  }

  .pika-week {
      font-size: 11px;
      color: #999;
  }

  .is-today .pika-button {
      color: #33aaff;
      font-weight: bold;
  }

  .is-selected .pika-button,
  .has-event .pika-button {
      color: #fff;
      font-weight: bold;
      background: #33aaff;
      box-shadow: inset 0 1px 3px #178fe5;
      border-radius: 3px;
  }

  .has-event .pika-button {
      background: #005da9;
      box-shadow: inset 0 1px 3px #0076c9;
  }

  .is-disabled .pika-button,
  .is-inrange .pika-button {
      background: #D5E9F7;
  }

  .is-startrange .pika-button {
      color: #fff;
      background: #6CB31D;
      box-shadow: none;
      border-radius: 3px;
  }

  .is-endrange .pika-button {
      color: #fff;
      background: #33aaff;
      box-shadow: none;
      border-radius: 3px;
  }

  .is-disabled .pika-button {
      pointer-events: none;
      cursor: default;
      color: #999;
      opacity: .3;
  }

  .is-outside-current-month .pika-button {
      color: #999;
      opacity: .3;
  }

  .is-selection-disabled {
      pointer-events: none;
      cursor: default;
  }

  .pika-button:hover,
  .pika-row.pick-whole-week:hover .pika-button {
      color: #fff;
      background: #ff8000;
      box-shadow: none;
      border-radius: 3px;
  }

  /* styling for abbr */
  .pika-table abbr {
      border-bottom: none;
      cursor: help;
  }

  .htCommentCell {
      position: relative;
  }

  .htCommentCell:after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      border-left: 6px solid transparent;
      border-top: 6px solid black;
  }

  .htComments {
      display: none;
      z-index: 1059;
      position: absolute;
  }

  .htCommentTextArea {
      box-shadow: rgba(0, 0, 0, 0.117647) 0 1px 3px, rgba(0, 0, 0, 0.239216) 0 1px 2px;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      border: none;
      border-left: 3px solid #ccc;
      background-color: #fff;
      width: 215px;
      height: 90px;
      font-size: 12px;
      padding: 5px;
      outline: 0px !important;
      -webkit-appearance: none;
  }

  .htCommentTextArea:focus {
      box-shadow: rgba(0, 0, 0, 0.117647) 0 1px 3px, rgba(0, 0, 0, 0.239216) 0 1px 2px, inset 0 0 0 1px #5292f7;
      border-left: 3px solid #5292f7;
  }

  /*!
  * Handsontable ContextMenu
  */

  .htContextMenu:not(.htGhostTable) {
    display: none;
    position: absolute;
    z-index: 1060; /* needs to be higher than 1050 - z-index for Twitter Bootstrap modal (#1569) */
  }

  .htContextMenu .ht_clone_top,
  .htContextMenu .ht_clone_left,
  .htContextMenu .ht_clone_corner {
    display: none;
  }

  .htContextMenu table.htCore {
    border: 1px solid #ccc;
    border-bottom-width: 2px;
    border-right-width: 2px;
  }

  .htContextMenu .wtBorder {
    visibility: hidden;
  }

  .htContextMenu table tbody tr td {
    background: white;
    border-width: 0;
    padding: 4px 6px 0 6px;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .htContextMenu table tbody tr td:first-child {
    border: 0;
  }

  .htContextMenu table tbody tr td.htDimmed {
    font-style: normal;
    color: #323232;
  }

  .htContextMenu table tbody tr td.current,
  .htContextMenu table tbody tr td.zeroclipboard-is-hover {
    background: #f3f3f3;
  }

  .htContextMenu table tbody tr td.htSeparator {
    border-top: 1px solid #e6e6e6;
    height: 0;
    padding: 0;
    cursor: default;
  }

  .htContextMenu table tbody tr td.htDisabled {
    color: #999;
    cursor: default;
  }

  .htContextMenu table tbody tr td.htDisabled:hover {
    background: #fff;
    color: #999;
    cursor: default;
  }

  .htContextMenu table tbody tr.htHidden {
    display: none;
  }

  .htContextMenu table tbody tr td .htItemWrapper {
    margin-left: 10px;
    margin-right: 6px;
  }

  .htContextMenu table tbody tr td div span.selected {
    margin-top: -2px;
    position: absolute;
    left: 4px;
  }

  .htContextMenu .ht_master .wtHolder {
    overflow: hidden;
  }

  textarea.HandsontableCopyPaste {
    position: fixed !important;
    top: 0 !important;
    right: 100% !important;
    overflow: hidden;
    opacity: 0;
    outline: 0 none !important;
  }

  .htRowHeaders .ht_master.innerBorderLeft ~ .ht_clone_top_left_corner th:nth-child(2),
  .htRowHeaders .ht_master.innerBorderLeft ~ .ht_clone_left td:first-of-type {
    border-left: 0 none;
  }

  .handsontable .wtHider {
    position: relative;
  }
  .handsontable.ht__manualColumnMove.after-selection--columns thead th.ht__highlight {
    cursor: move;
    cursor: -moz-grab;
    cursor: -webkit-grab;
    cursor: grab;
  }
  .handsontable.ht__manualColumnMove.on-moving--columns,
  .handsontable.ht__manualColumnMove.on-moving--columns thead th.ht__highlight {
    cursor: move;
    cursor: -moz-grabbing;
    cursor: -webkit-grabbing;
    cursor: grabbing;
  }
  .handsontable.ht__manualColumnMove.on-moving--columns .manualColumnResizer {
    display: none;
  }
  .handsontable .ht__manualColumnMove--guideline,
  .handsontable .ht__manualColumnMove--backlight {
    position: absolute;
    height: 100%;
    display: none;
  }
  .handsontable .ht__manualColumnMove--guideline {
    background: #757575;
    width: 2px;
    top: 0;
    margin-left: -1px;
    z-index: 205;
  }
  .handsontable .ht__manualColumnMove--backlight {
    background: #343434;
    background: rgba(52, 52, 52, 0.25);
    display: none;
    z-index: 205;
    pointer-events: none;
  }
  .handsontable.on-moving--columns.show-ui .ht__manualColumnMove--guideline,
  .handsontable.on-moving--columns .ht__manualColumnMove--backlight {
    display: block;
  }

  .handsontable .wtHider {
    position: relative;
  }
  .handsontable.ht__manualRowMove.after-selection--rows tbody th.ht__highlight {
    cursor: move;
    cursor: -moz-grab;
    cursor: -webkit-grab;
    cursor: grab;
  }
  .handsontable.ht__manualRowMove.on-moving--rows,
  .handsontable.ht__manualRowMove.on-moving--rows tbody th.ht__highlight {
    cursor: move;
    cursor: -moz-grabbing;
    cursor: -webkit-grabbing;
    cursor: grabbing;
  }
  .handsontable.ht__manualRowMove.on-moving--rows .manualRowResizer {
    display: none;
  }
  .handsontable .ht__manualRowMove--guideline,
  .handsontable .ht__manualRowMove--backlight {
    position: absolute;
    width: 100%;
    display: none;
  }
  .handsontable .ht__manualRowMove--guideline {
    background: #757575;
    height: 2px;
    left: 0;
    margin-top: -1px;
    z-index: 205;
  }
  .handsontable .ht__manualRowMove--backlight {
    background: #343434;
    background: rgba(52, 52, 52, 0.25);
    display: none;
    z-index: 205;
    pointer-events: none;
  }
  .handsontable.on-moving--rows.show-ui .ht__manualRowMove--guideline,
  .handsontable.on-moving--rows .ht__manualRowMove--backlight {
    display: block;
  }

  .handsontable tbody td[rowspan][class*="area"][class*="highlight"]:not([class*="fullySelectedMergedCell"]):before {
      opacity: 0;
  }

  .handsontable tbody td[rowspan][class*="area"][class*="highlight"][class*="fullySelectedMergedCell-multiple"]:before {
      opacity: 0.1;
  }

  .handsontable tbody td[rowspan][class*="area"][class*="highlight"][class*="fullySelectedMergedCell-0"]:before {
      opacity: 0.1;
  }

  .handsontable tbody td[rowspan][class*="area"][class*="highlight"][class*="fullySelectedMergedCell-1"]:before {
      opacity: 0.2;
  }

  .handsontable tbody td[rowspan][class*="area"][class*="highlight"][class*="fullySelectedMergedCell-2"]:before {
      opacity: 0.27;
  }

  .handsontable tbody td[rowspan][class*="area"][class*="highlight"][class*="fullySelectedMergedCell-3"]:before {
      opacity: 0.35;
  }

  .handsontable tbody td[rowspan][class*="area"][class*="highlight"][class*="fullySelectedMergedCell-4"]:before {
      opacity: 0.41;
  }

  .handsontable tbody td[rowspan][class*="area"][class*="highlight"][class*="fullySelectedMergedCell-5"]:before {
      opacity: 0.47;
  }

  .handsontable tbody td[rowspan][class*="area"][class*="highlight"][class*="fullySelectedMergedCell-6"]:before {
      opacity: 0.54;
  }

  .handsontable tbody td[rowspan][class*="area"][class*="highlight"][class*="fullySelectedMergedCell-7"]:before {
      opacity: 0.58;
  }

  /*!
  * Handsontable DropdownMenu
  */
  .handsontable .changeType {
    background: #eee;
    border-radius: 2px;
    border: 1px solid #bbb;
    color: #bbb;
    font-size: 9px;
    line-height: 9px;
    padding: 2px;
    margin: 3px 1px 0 5px;
    float: right;
  }
  .handsontable .changeType:before {
    content: '\25BC\ ';
  }

  .handsontable .changeType:hover {
    border: 1px solid #777;
    color: #777;
    cursor: pointer;
  }

  .htDropdownMenu:not(.htGhostTable) {
    display: none;
    position: absolute;
    z-index: 1060; /* needs to be higher than 1050 - z-index for Twitter Bootstrap modal (#1569) */
  }

  .htDropdownMenu .ht_clone_top,
  .htDropdownMenu .ht_clone_left,
  .htDropdownMenu .ht_clone_corner {
    display: none;
  }

  .htDropdownMenu table.htCore {
    border: 1px solid #bbb;
    border-bottom-width: 2px;
    border-right-width: 2px;
  }

  .htDropdownMenu .wtBorder {
    visibility: hidden;
  }

  .htDropdownMenu table tbody tr td {
    background: white;
    border-width: 0;
    padding: 4px 6px 0 6px;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .htDropdownMenu table tbody tr td:first-child {
    border: 0;
  }

  .htDropdownMenu table tbody tr td.htDimmed {
    font-style: normal;
    color: #323232;
  }

  .htDropdownMenu table tbody tr td.current,
  .htDropdownMenu table tbody tr td.zeroclipboard-is-hover {
    background: #e9e9e9;
  }

  .htDropdownMenu table tbody tr td.htSeparator {
    border-top: 1px solid #e6e6e6;
    height: 0;
    padding: 0;
    cursor: default;
  }

  .htDropdownMenu table tbody tr td.htDisabled {
    color: #999;
  }

  .htDropdownMenu table tbody tr td.htDisabled:hover {
    background: #fff;
    color: #999;
    cursor: default;
  }

  .htDropdownMenu:not(.htGhostTable) table tbody tr.htHidden {
    display: none;
  }

  .htDropdownMenu table tbody tr td .htItemWrapper {
    margin-left: 10px;
    margin-right: 10px;
  }

  .htDropdownMenu table tbody tr td div span.selected {
    margin-top: -2px;
    position: absolute;
    left: 4px;
  }

  .htDropdownMenu .ht_master .wtHolder {
    overflow: hidden;
  }

  /* Column's number position */
  .handsontable span.colHeader.columnSorting::after {
    /* Centering start */
    top: 50%;
    margin-top: -2px; /* Two extra pixels (-2 instead of -4) for purpose of proper positioning of numeric indicators, when `font-size` set to default */
    /* Centering end */

    position: absolute;
    right: -15px;
    padding-left: 5px; ; /* For purpose of continuous mouse over experience, when moving between the `::before` and the `::after` elements */

    font-size: 8px;
    height: 8px;
    line-height: 1.1;
    text-decoration: underline; /* Workaround for IE9 - IE11 */
  }

  /* Workaround for IE9 - IE11, https://stackoverflow.com/a/21902566, https://stackoverflow.com/a/32120247 */
  .handsontable span.colHeader.columnSorting::after {
    text-decoration: none;
  }

  /* We support up to 7 numeric indicators, describing order of column in sorted columns queue */
  .handsontable span.colHeader.columnSorting[class^="sort-"]::after,
  .handsontable span.colHeader.columnSorting[class*=" sort-"]::after {
    content: "+"
  }

  .handsontable span.colHeader.columnSorting.sort-1::after {
    content: '1';
  }

  .handsontable span.colHeader.columnSorting.sort-2::after {
    content: '2';
  }

  .handsontable span.colHeader.columnSorting.sort-3::after {
    content: '3';
  }

  .handsontable span.colHeader.columnSorting.sort-4::after {
    content: '4';
  }

  .handsontable span.colHeader.columnSorting.sort-5::after {
    content: '5';
  }

  .handsontable span.colHeader.columnSorting.sort-6::after {
    content: '6';
  }

  .handsontable span.colHeader.columnSorting.sort-7::after {
    content: '7';
  }

  /* Drop-down menu widens header by 5 pixels, sort sequence numbers won't overlap the icon; mainly for the IE9+ */
  .htGhostTable th div button.changeType + span.colHeader.columnSorting:not(.indicatorDisabled) {
    padding-right: 5px;
  }

  /*!
  * Handsontable Filters
  */

  /* Conditions menu */
  .htFiltersConditionsMenu:not(.htGhostTable) {
    display: none;
    position: absolute;
    z-index: 1070;
  }

  .htFiltersConditionsMenu .ht_clone_top,
  .htFiltersConditionsMenu .ht_clone_left,
  .htFiltersConditionsMenu .ht_clone_corner {
    display: none;
  }

  .htFiltersConditionsMenu table.htCore {
    border: 1px solid #bbb;
    border-bottom-width: 2px;
    border-right-width: 2px;
  }

  .htFiltersConditionsMenu .wtBorder {
    visibility: hidden;
  }

  .htFiltersConditionsMenu table tbody tr td {
    background: white;
    border-width: 0;
    padding: 4px 6px 0 6px;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .htFiltersConditionsMenu table tbody tr td:first-child {
    border: 0;
  }

  .htFiltersConditionsMenu table tbody tr td.htDimmed {
    font-style: normal;
    color: #323232;
  }

  .htFiltersConditionsMenu table tbody tr td.current,
  .htFiltersConditionsMenu table tbody tr td.zeroclipboard-is-hover {
    background: #e9e9e9;
  }

  .htFiltersConditionsMenu table tbody tr td.htSeparator {
    border-top: 1px solid #e6e6e6;
    height: 0;
    padding: 0;
  }

  .htFiltersConditionsMenu table tbody tr td.htDisabled {
    color: #999;
  }

  .htFiltersConditionsMenu table tbody tr td.htDisabled:hover {
    background: #fff;
    color: #999;
    cursor: default;
  }

  .htFiltersConditionsMenu table tbody tr td .htItemWrapper {
    margin-left: 10px;
    margin-right: 10px;
  }

  .htFiltersConditionsMenu table tbody tr td div span.selected {
    margin-top: -2px;
    position: absolute;
    left: 4px;
  }

  .htFiltersConditionsMenu .ht_master .wtHolder {
    overflow: hidden;
  }

  .handsontable .htMenuFiltering {
    border-bottom: 1px dotted #ccc;
    height: 135px;
    overflow: hidden;
  }

  .handsontable .ht_master table td.htCustomMenuRenderer {
    background-color: #fff;
    cursor: auto;
  }

  /* Menu label */
  .handsontable .htFiltersMenuLabel {
    font-size: 0.75em;
  }

  /* Component action bar */
  .handsontable .htFiltersMenuActionBar {
    text-align: center;
    padding-top: 10px;
    padding-bottom: 3px;
  }

  /* Component filter by conditional */
  .handsontable .htFiltersMenuCondition.border {
    border-bottom: 1px dotted #ccc !important;
  }
  .handsontable .htFiltersMenuCondition .htUIInput {
    padding: 0 0 5px 0;
  }

  /* Component filter by value */
  .handsontable .htFiltersMenuValue {
    border-bottom: 1px dotted #ccc !important;
  }
  .handsontable .htFiltersMenuValue .htUIMultipleSelectSearch {
    padding: 0;
  }
  .handsontable .htFiltersMenuCondition .htUIInput input,
  .handsontable .htFiltersMenuValue .htUIMultipleSelectSearch input {
    font-family: inherit;
    font-size: 0.75em;
    padding: 4px;
    box-sizing: border-box;
    width: 100%;
  }

  .htUIMultipleSelect .ht_master .wtHolder {
    overflow-y: scroll;
  }

  .handsontable .htFiltersActive .changeType {
    border: 1px solid #509272;
    color: #18804e;
    background-color: #d2e0d9;
  }

  .handsontable .htUISelectAll {
    margin-right: 10px;
  }

  .handsontable .htUIClearAll, .handsontable .htUISelectAll {
    display: inline-block;
  }

  .handsontable .htUIClearAll a, .handsontable .htUISelectAll a {
    color: #3283D8;
    font-size: 0.75em;
  }

  .handsontable .htUISelectionControls {
    text-align: right;
  }

  .handsontable .htCheckboxRendererInput {
    margin: 0 5px 0 0;
    vertical-align: middle;
    height: 1em;
  }

  /* UI elements */
  /* Input */
  .handsontable .htUIInput {
    padding: 3px 0 7px 0;
    position: relative;
    text-align: center;
  }
  .handsontable .htUIInput input {
    border-radius: 2px;
    border: 1px solid #d2d1d1;
  }
  .handsontable .htUIInput input:focus {
    outline: 0;
  }
  .handsontable .htUIInputIcon {
    position: absolute;
  }

  /* Button */
  .handsontable .htUIInput.htUIButton {
    cursor: pointer;
    display: inline-block;
  }
  .handsontable .htUIInput.htUIButton input {
    background-color: #eee;
    color: #000;
    cursor: pointer;
    font-family: inherit;
    font-size: 0.7em;
    font-weight: bold;
    height: 19px;
    min-width: 64px;
  }
  .handsontable .htUIInput.htUIButton input:hover {
    border-color: #b9b9b9;
  }

  .handsontable .htUIInput.htUIButtonOK {
    margin-right: 10px;
  }

  .handsontable .htUIInput.htUIButtonOK input {
    background-color: #0f9d58;
    border-color: #18804e;
    color: #fff;
  }
  .handsontable .htUIInput.htUIButtonOK input:hover {
    border-color: #1a6f46;
  }

  /* Select */
  .handsontable .htUISelect {
    cursor: pointer;
    margin-bottom: 7px;
    position: relative;
  }
  .handsontable .htUISelectCaption {
    background-color: #e8e8e8;
    border-radius: 2px;
    border: 1px solid #d2d1d1;
    font-family: inherit;
    font-size: 0.7em;
    font-weight: bold;
    padding: 3px 20px 3px 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .handsontable .htUISelectCaption:hover {
    background-color: #e8e8e8;
    border: 1px solid #b9b9b9;
  }
  .handsontable .htUISelectDropdown:after {
    content: '\25B2';
    font-size: 7px;
    position: absolute;
    right: 10px;
    top: 0;
  }
  .handsontable .htUISelectDropdown:before {
    content: '\25BC';
    font-size: 7px;
    position: absolute;
    right: 10px;
    top: 8px;
  }

  /* SelectMultiple */
  .handsontable .htUIMultipleSelect .handsontable .htCore {
    border: none;
  }
  .handsontable .htUIMultipleSelect .handsontable .htCore td:hover {
    background-color: #F5F5F5;
  }

  .handsontable .htUIMultipleSelectSearch input {
    border-radius: 2px;
    border: 1px solid #d2d1d1;
    padding: 3px;
  }

  .handsontable .htUIRadio {
    display: inline-block;
    margin-right: 5px;
    height: 100%;
  }

  .handsontable .htUIRadio:last-child {
    margin-right: 0;
  }

  .handsontable .htUIRadio > input[type=radio] {
    margin-right: 0.5ex;
  }

  .handsontable .htUIRadio label {
    vertical-align: middle;
  }

  .handsontable .htFiltersMenuOperators {
    padding-bottom: 5px;
  }

  .handsontable.ganttChart tr:first-child th div.relative {
    padding-right: 21px;
  }
  .handsontable.ganttChart .colHeader {
    display: block;
  }
  .handsontable.ganttChart td.rangeBar {
    background: #48b703;
    border-right-width: 0;
    position: relative;
    -webkit-box-shadow: inset 0 3px 0 #ffffff;
    -moz-box-shadow: inset 0 3px 0 #ffffff;
    box-shadow: inset 0 3px 0 #ffffff;
  }
  .handsontable.ganttChart td.rangeBar.last {
    border-right-width: 1px;
  }
  .handsontable.ganttChart td.rangeBar.area {
    background: #7EC481;
  }
  .handsontable.ganttChart td.rangeBar.partial {
    background: #8edf5a;
  }
  .handsontable.ganttChart td.rangeBar.area.partial {
    background: #A1D8AD;
  }

  .handsontable thead th.hiddenHeader:not(:first-of-type) {
    display: none;
  }

  .handsontable th.ht_nestingLevels {
      text-align: left;
      padding-left: 7px;
  }

  .handsontable th div.ht_nestingLevels {
      display: inline-block;
      position: absolute;
      left: 11px;
  }

  .handsontable.innerBorderLeft th div.ht_nestingLevels,
  .handsontable.innerBorderLeft ~ .handsontable th div.ht_nestingLevels {
      right: 10px;
  }

  .handsontable th span.ht_nestingLevel {
      display: inline-block;
  }

  .handsontable th span.ht_nestingLevel_empty {
      display: inline-block;
      width: 10px;
      height: 1px;
      float: left;
  }

  .handsontable th span.ht_nestingLevel::after {
      content: "\2510";
      font-size: 9px;
      display: inline-block;
      position: relative;
      bottom: 3px;
  }

  .handsontable th div.ht_nestingButton {
      display: inline-block;
      position: absolute;
      right: -2px;
      cursor: pointer;
  }

  .handsontable th div.ht_nestingButton.ht_nestingExpand::after {
      content: "\002B";
  }

  .handsontable th div.ht_nestingButton.ht_nestingCollapse::after {
      content: "\002D";
  }

  .handsontable.innerBorderLeft th div.ht_nestingButton,
  .handsontable.innerBorderLeft ~ .handsontable th div.ht_nestingButton {
      right: 0;
  }
  /*
  * Handsontable HiddenColumns
  */
  .handsontable th.beforeHiddenColumn {
    position: relative;
  }

  .handsontable th.beforeHiddenColumn::after,
  .handsontable th.afterHiddenColumn::before {
    color: #bbb;
    position: absolute;
    top: 50%;
    font-size: 5pt;
    transform: translateY(-50%);
  }

  .handsontable th.afterHiddenColumn {
    position: relative;
  }
  .handsontable th.beforeHiddenColumn::after {
    right: 1px;
    content: '\25C0';
  }
  .handsontable th.afterHiddenColumn::before {
    left: 1px;
    content: '\25B6';
  }

  .handsontable td.firstVisibleColumn,
  .handsontable th.firstVisibleColumn {
    border-left: 1px solid #CCC;
  }

  /*!
  * Handsontable HiddenRows
  */
  .handsontable th.beforeHiddenRow::before,
  .handsontable th.afterHiddenRow::after {
    color: #bbb;
    font-size: 6pt;
    line-height: 6pt;
    position: absolute;
    left: 2px;
  }

  .handsontable th.beforeHiddenRow,
  .handsontable th.afterHiddenRow {
    position: relative;
  }

  .handsontable th.beforeHiddenRow::before {
    content: '\25B2';
    bottom: 2px;
  }

  .handsontable th.afterHiddenRow::after {
    content: '\25BC';
    top: 2px;
  }
  .handsontable.ht__selection--rows tbody th.beforeHiddenRow.ht__highlight:before,
  .handsontable.ht__selection--rows tbody th.afterHiddenRow.ht__highlight:after {
    color: #eee;
  }
  .handsontable td.afterHiddenRow.firstVisibleRow,
  .handsontable th.afterHiddenRow.firstVisibleRow {
    border-top: 1px solid #CCC;
  }
</style>
